import React, { useEffect, useRef, useState, useMemo, useCallback } from "react";
import { debounce } from "lodash";
import {
  Button,
  makeStyles,
  Grid,
  MenuItem,
  TextField,
  InputAdornment,
  Tooltip,
  IconButton,
  Typography,
  Box,
  FormControl,
  Select,
  Checkbox,
  ListItemText,
  CircularProgress,
  useMediaQuery,
  useTheme,
  Dialog,
  DialogContent,
  Popover,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@material-ui/core";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import EventIcon from "@material-ui/icons/Event";
import {
  fetchPurchaseOrdersDashboardFilters,
  fetchPurchaseOrdersNew,
  fetchInActivePurchaseOrders,
  fetchFGStatus,
} from "../../../containers/actions/common/purchaseOrderAction";
import { fetchAllDashboardFilters, extractDashboardFilters } from "../../../containers/utils/filterUtils";
import { FETCH_PURCHASE_ORDER_FILTER } from "../../../containers/actions/types";
import { useHistory } from "react-router-dom";
import jwt_decode from "jwt-decode";
import moment from "moment";
import { Clear, Refresh, CloudDownload, ChevronLeft, ChevronRight } from "@material-ui/icons";
import SearchIcon from "@material-ui/icons/Search";
import { useDispatch, useSelector } from "react-redux";
import usePrevious from "../../helpers/previousProps";
import { getFeaturesAccess } from "../../../containers/actions/common/accessControl";
import {
  DESTROY_BACKDROP,
  FETCH_PURCHASE_ORDER_LOADING,
  OPEN_BACKDROP,
} from "../../../containers/actions/types";
import jwtDecode from "jwt-decode";
import { cmoMembersList } from "../../../containers/actions/pharmaCo/purchaseOrderActions";
import axios from "axios";
import { appUrl } from "../../../../../utils/config";
import ClearIcon from "@material-ui/icons/Clear";
import CloseIcon from "@material-ui/icons/Close";
import { fetchUserAssociation } from "../../../containers/actions/common/purchaseOrderAction";
import { saveDashboardFilters } from "../../../containers/utils/filterUtils";
import InactivePOTable from "./InactivePOTable";
import ResetBatchDialogInactive from "./ResetBatchDialogInactive";
import DocumentResubmissionDialog from "./DocumentResubmissionDialog";
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import StyledDialog from "../../../../common/models/Dialog";
import WarningIcon from "@material-ui/icons/Warning";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ErrorIcon from "@material-ui/icons/Error";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    paddingTop: theme.spacing(0.5),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1),
      paddingTop: theme.spacing(0.5),
    },
  },
  filterSection: {
    marginBottom: theme.spacing(6),
    padding: 0,
    border: "none",
    boxShadow: "none",
    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing(3),
    },
  },
  filterRow: {
    display: "flex",
    alignItems: "flex-end",
    gap: theme.spacing(2),
    flexWrap: "wrap",
    marginBottom: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      gap: theme.spacing(1.5),
    },
  },
  filterLabel: {
    fontWeight: "bold",
    minWidth: "100px",
    fontSize: "14px",
    [theme.breakpoints.down('sm')]: {
      minWidth: "80px",
      fontSize: "12px",
    },
  },
  filterControl: {
    minWidth: "150px",
    maxWidth: "200px",
    [theme.breakpoints.down('sm')]: {
      minWidth: "120px",
      maxWidth: "150px",
    },
  },
  saveButton: {
    backgroundColor: "#ec6535",
    color: "#fff",
    textTransform: "none",
    borderRadius: "2rem",
    padding: "5px 20px",
    "&:hover": {
      backgroundColor: "#d4572e",
    },
  },
  clearButton: {
    color: "blue",
    textDecoration: "underline",
    cursor: "pointer",
    fontSize: "14px",
  },
  searchSection: {
    display: "flex",
    alignItems: "flex-start",
    gap: theme.spacing(4),
    marginBottom: theme.spacing(6),
    width: "100%",
    [theme.breakpoints.down('md')]: {
      flexDirection: "column",
      gap: theme.spacing(2),
    },
    [theme.breakpoints.down('sm')]: {
      gap: theme.spacing(1.5),
    },
  },
  searchGroup: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(0.5),
    minWidth: 0,
    flex: 1,
    [theme.breakpoints.down('md')]: {
      width: "100%",
    },
  },
  searchLabel: {
    fontWeight: "bold",
    fontSize: "14px",
    marginBottom: theme.spacing(0.5),
  },
  actionGroup: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(0.5),
  },
  actionLabel: {
    fontWeight: "bold",
    fontSize: "14px",
    marginBottom: theme.spacing(0.5),
  },
  syncGroup: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    gap: theme.spacing(1),
    marginLeft: "auto",
    [theme.breakpoints.down('md')]: {
      alignItems: "flex-start",
      marginLeft: 0,
      width: "100%",
    },
    [theme.breakpoints.down('sm')]: {
      alignItems: "stretch",
      "& > *": {
        width: "100%",
      },
    },
  },
  actionSection: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: theme.spacing(3),
    marginBottom: theme.spacing(2),
    flexWrap: "wrap",
    [theme.breakpoints.down('sm')]: {
      gap: theme.spacing(1.5),
      flexDirection: "column",
      alignItems: "flex-start",
    },
  },
  downloadButton: {
    backgroundColor: "#fff",
    color: "#000",
    textTransform: "none",
    borderRadius: "2rem",
    padding: "5px 20px",
    border: "1px solid #000",
    boxShadow: "none",
    "&:hover": {
      backgroundColor: "#000",
      color: "#fff",
      boxShadow: "none",
    },

  },
  syncInfo: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    fontSize: "14px",
  },
  perPageSection: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  tableContainer: {
    marginTop: theme.spacing(4),
    width: "100%",
    overflowX: "auto",
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(2),
    },
  },
  menuPaper: {
    maxHeight: 300,
    overflow: "auto",
  },
}));

const InactivePODashboard = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const tokenData = jwtDecode(localStorage.getItem("authToken"));

  // Redux selectors - same as PO Dashboard
  let cmoMemberWithId = useSelector((state) =>
    state.pcmp.pharmaCo.purchaseOrder.cmoMemberWithId
      ? state.pcmp.pharmaCo.purchaseOrder.cmoMemberWithId
      : []
  );
  const userAssociationData = useSelector(
    (state) => state.pcmp?.common?.purchaseOrder?.userAssociationResult || null
  );

  // Screen access for Delivered/Deleted POs screen
  const screenAccess = useSelector(
    (state) =>
      state.pcmp.common.accessControl.screensAccess?.data?.deliveredDeletedPO
  );

  // Features access for Delivered/Deleted POs screen
  const featuresAccess = useSelector(
    (state) =>
      state.pcmp.common.accessControl.featuresAccess.deliveredDeletedPOFeatures
  );


  const [SelectedCMOList, setSelectedCMOList] = useState([]);
  const [selectedCMOs, setSelectedCMOs] = useState([]);
  const [selectedPlantIdList, setSelectedPlantIdList] = useState([]);
  const [filteredPlantList, setFilteredPlantList] = useState([]);
  const [selectedPlannerList, setSelectedPlannerList] = useState([]);
  const [selectedPlanners, setSelectedPlanners] = useState([]);
  const [selectedBrandList, setSelectedBrandList] = useState([]);
  const [selectedBrands, setSelectedBrands] = useState([]);
  const [selectedProductType, setSelectedProductType] = useState([]);

  // Filter options - same as PO Dashboard
  const [allReceivingPlants, setAllReceivingPlants] = useState([]);
  const [plantList, setPlantList] = useState([]);
  const [plannerList, setPlannerList] = useState([]);
  const [brandList, setBrandList] = useState([]);
  const [plantIdOptions, setPlantIdOptions] = useState([]);
  const [plannerOptions, setPlannerOptions] = useState([]);
  const [brandOptions, setBrandOptions] = useState([]);
  const [productTypeOptions, setProductTypeOptions] = useState([]);
  const [originalProductTypeOptions, setOriginalProductTypeOptions] = useState([]);
  const [filteredVendorMosymphonyIDList, setFilteredVendorMosymphonyIDList] = useState([]);
  const [mfgPlantList, setMFGPlantList] = useState([]);
  const [originalMfgPlantList, setOriginalMfgPlantList] = useState([]);
  const [selectedMFGPlantList, setSelectedMFGPlantList] = useState([]);

  // Search states
  const [searchField, setSearchField] = useState("all");
  const [searchValue, setSearchValue] = useState("");
  const [selectedDate, setSelectedDate] = useState(null);
  const [datePickerOpen, setDatePickerOpen] = useState(false);
  const datePickerAnchorRef = useRef(null);
  const [selectedAction, setSelectedAction] = useState("View all PO");
  const [searchFieldSelectOpen, setSearchFieldSelectOpen] = useState(false);

  const [poStatusArray, setPOStatusArray] = useState([]);
  const [selectedPOStatuses, setSelectedPOStatuses] = useState([]);
  const [marketValues, setMarketValues] = useState([]);
  const [displayMarketValues, setDisplayMarketValues] = useState([]);
  const [originalMarketValues, setOriginalMarketValues] = useState([]);
  const [selectedMarkets, setSelectedMarkets] = useState([]);
  const [regionValues, setRegionValues] = useState([]);
  const [displayRegionValues, setDisplayRegionValues] = useState([]);
  const [originalRegionValues, setOriginalRegionValues] = useState([]);
  const [selectedRegions, setSelectedRegions] = useState([]);

  // PO-Level Reason Code dropdown states
  const [poLevelReasonCodeOptions, setPoLevelReasonCodeOptions] = useState([]);
  const [selectedPoLevelReasonCodes, setSelectedPoLevelReasonCodes] = useState([]);

  // NEW: Sort by PO Stat Date filter states (F1)
  const [poStatDateStart, setPoStatDateStart] = useState(null);
  const [poStatDateEnd, setPoStatDateEnd] = useState(null);

  // Reset Batch dialog state
  const [resetBatchDialogOpen, setResetBatchDialogOpen] = useState(false);
  const [documentResubmissionDialogOpen, setDocumentResubmissionDialogOpen] = useState(false);
  const [resetBatchData, setResetBatchData] = useState(null);
  const [successDialogOpen, setSuccessDialogOpen] = useState(false);
  const [consumptionLoading, setConsumptionLoading] = useState(false);
  const [consumptionError, setConsumptionError] = useState(null);

  // Save filter dialog states
  const [savedSuccessfull, setSavedSuccessfull] = useState(false);
  const [saveFailed, setSaveFailed] = useState(false);
  const [savingFilters, setSavingFilters] = useState(false);

  // Validation function for search values
  const validateSearchValue = (value) => {
    const trimmedValue = value.trim();

    if (searchField === "PO Number") {
      // Allow only numbers
      const regex = /^[0-9]+$/;
      return regex.test(trimmedValue);
    } else if (searchField === "Product Code") {
      // Allow numbers and hyphens
      const regex = /^[0-9\-]+$/;
      return regex.test(trimmedValue);
    } else if (searchField === "Product Description" || searchField === "Product description") {
      const regex = /^[A-Za-z0-9. ]+$/;
      return regex.test(trimmedValue);
    }

    return true;
  };

  // Handle search field change (same pattern as PO Dashboard)
  const handleSearchField = (event) => {
    const newSearchField = event.target.value;
    setSearchField(newSearchField);

    if (searchField === "Date of PO Creation" && newSearchField !== "Date of PO Creation") {
      setSelectedDate(null);
      setDatePickerOpen(false);
    }

    if (newSearchField === "PO Status") {
      setSearchValue([]);
      setSelectedPOStatuses([]);
    } else if (newSearchField === "Market") {
      setSearchValue([]);
      setSelectedMarkets([]);
    } else if (newSearchField === "Region") {
      setSearchValue([]);
      setSelectedRegions([]);
    } else if (newSearchField === "PO-Level Reason Code") {
      setSearchValue([]);
      setSelectedPoLevelReasonCodes([]);
    } else if (newSearchField === "Date of PO Creation") {
      setSearchValue("");
      setSelectedDate(null);
    } else {
      setSearchValue("");
      setSelectedDate(null);
    }
  };

  // Handle search value change with validation 
  const handleSearchValue = (event) => {
    const newValue = event.target.value;
    if (validateSearchValue(newValue) || newValue === "") {
      setSearchValue(newValue);
    }
  };

  // Handle date change for Date of PO Creation
  const handleDateChange = (date) => {
    if (date && moment(date).isValid()) {
      setSelectedDate(date);
      const formattedDate = moment(date).format("YYYY-MM-DD");
      setSearchValue(formattedDate);
    } else {
      setSelectedDate(null);
      setSearchValue("");
    }
  };

  // Data states
  const [poData, setPoData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [lastSynced, setLastSynced] = useState(new Date());
  // Saved filters
  const [savedFilter, setSavedFilter] = useState({});

  let previousVendorList = useRef([]);
  let previousPlantList = useRef([]);
  let previousPlannerList = useRef([]);
  let previousBrandList = useRef([]);
  let previousProductTypeList = useRef([]);
  let previousMfgPlantList = useRef([]);

  const purchaseOrderFilter = useSelector((state) =>
    state.pcmp.common?.purchaseOrder?.purchaseOrderDetailsFilters?.status
      ? state.pcmp.common?.purchaseOrder?.purchaseOrderDetailsFilters
      : {}
  );

  let previousFilters = useRef({});
  let previousApiFilters = useRef({});
  let previousSavedFilter = useRef(null);
  const previousPaginationParams = useRef({ page: 1, pageSize: 10 });
  const [filtersLoadedFromAPI, setFiltersLoadedFromAPI] = useState(false);
  const hasMadeFirstAPICall = useRef(false);

  // Fetch features for Delivered/Deleted POs screen using screenId
  useEffect(() => {
    if (screenAccess?.screenAccess && !featuresAccess) {
      dispatch(getFeaturesAccess(screenAccess?.screenId, "deliveredDeletedPOFeatures"));
    }
  }, [dispatch, screenAccess, featuresAccess]);

  useEffect(() => {
    dispatch({
      type: FETCH_PURCHASE_ORDER_FILTER,
      payload: { status: false }
    });

    // Reset previousFilters, previousApiFilters and filtersLoadedFromAPI to ensure fresh start
    previousFilters.current = {};
    previousApiFilters.current = {}; // Reset to allow API call on hard refresh
    hasMadeFirstAPICall.current = false; // Reset first API call flag
    setFiltersLoadedFromAPI(false);

    fetchAllDashboardFilters()
      .then((allFilters) => {
        const inactivePOFilters = extractDashboardFilters(allFilters, 'inactivePODashboard');
        dispatch({
          type: FETCH_PURCHASE_ORDER_FILTER,
          payload: inactivePOFilters
        });
        setFiltersLoadedFromAPI(true);
      })
      .catch((err) => {
        console.error("Error fetching inactive PO filters:", err);
        dispatch({
          type: FETCH_PURCHASE_ORDER_FILTER,
          payload: { status: false }
        });
        setFiltersLoadedFromAPI(true); // Mark as loaded even on error (useEffect will reset previousApiFilters)
      });

    dispatch(fetchFGStatus())
      .then((res) => {
        if (res?.status) {
          const statuses = res?.data?.poStatuses || [];
          const filteredStatuses = statuses.filter(status => status.status_id === 30);
          const cancelledStatus = {
            status_id: 0,
            status_name: "Cancelled"
          };
          setPOStatusArray([...filteredStatuses, cancelledStatus]);
        }
      })
      .catch((err) => {
        console.error("Error fetching PO statuses:", err);
      });

    // Fetch Market Values - same as PO Dashboard
    axios
      .get(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchMarketValues`
      )
      .then((res) => {
        if (res.data?.status) {
          const marketList = res.data?.data ? res.data?.data.map(item => ({
            market_group: item.market_group,
            marketorder_be: item.marketorder_be,
            count_items: item.count_items
          })) : [];
          setMarketValues(marketList);
          setDisplayMarketValues(marketList);
          setOriginalMarketValues(marketList);
        }
      })
      .catch((err) => {
        console.error("Error fetching market values:", err);
      });

    // Fetch Region Codes - same as PO Dashboard
    axios
      .get(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchRegionCodes`
      )
      .then((res) => {
        if (res.data?.status) {
          const regionList = res.data?.RegionCodes ? res.data.RegionCodes.map(regionCode => ({
            regionCode: regionCode
          })) : [];
          setRegionValues(regionList);
          setDisplayRegionValues(regionList);
          setOriginalRegionValues(regionList);
        }
      })
      .catch((err) => {
        console.error("Error fetching region codes:", err);
      });

    // Fetch PO-Level Reason Codes
    axios
      .post(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchReasonCodesDirect`,
        {
          searchField: "all",
          searchValue: "",
          reasonCodeGroupType: "all",
          reasonCodeType: "all",
          status: "all",
          collaboratorTypeID: "all",
        }
      )
      .then((res) => {
        if (res.data?.status) {
          const reasonCodeList = res?.data?.data?.reasonCodeList || [];
          setPoLevelReasonCodeOptions(reasonCodeList);
        }
      })
      .catch((err) => {
        console.error("Error fetching PO-Level Reason Codes:", err);
        setPoLevelReasonCodeOptions([]);
      });

    // Dispatch CMO members action - same as PO Dashboard
    let { collabType, ecosystemId, organizationName, roleName } = localStorage;
    if (collabType !== "CMO") {
      dispatch(
        cmoMembersList({
          collabType: collabType,
          roleName: roleName,
          organizationName: organizationName,
          ecosystemId: ecosystemId,
        })
      );
    }

    let isMounted = true;

    // Fetch all receiving plant IDs and storage location IDs - same as PO Dashboard
    axios
      .get(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchAllReceivingPlantIDsAndStorageLocationIDsDirect/all`
      )
      .then((res) => {
        if (isMounted && res.data?.vendorOrgLevelData) {
          const formattedPlants = res.data.vendorOrgLevelData.flatMap((item) =>
            (item.receivingPlantIDs || [])
              .filter((id) => id)
              .map((id) => ({
                plantCode: id,
                vendorMosymphonyID: item.vendorMosymphonyID,
              }))
          );

          const plantGroups = formattedPlants.reduce((acc, plant) => {
            if (!acc[plant.plantCode]) {
              acc[plant.plantCode] = {
                plantCode: plant.plantCode,
                vendorMosymphonyIDs: [],
              };
            }
            if (!acc[plant.plantCode].vendorMosymphonyIDs.includes(plant.vendorMosymphonyID)) {
              acc[plant.plantCode].vendorMosymphonyIDs.push(plant.vendorMosymphonyID);
            }
            return acc;
          }, {});

          const uniquePlants = Object.values(plantGroups).map(plant => ({
            plantCode: plant.plantCode,
            vendorMosymphonyID: plant.vendorMosymphonyIDs[0],
            allVendorMosymphonyIDs: plant.vendorMosymphonyIDs,
          }));

          setAllReceivingPlants(uniquePlants);
          setPlantList(uniquePlants);
          setPlantIdOptions(uniquePlants);
        } else if (isMounted) {
          setAllReceivingPlants([]);
          setPlantList([]);
          setPlantIdOptions([]);
        }
      })
      .catch((err) => {
        if (isMounted) {
          console.error(
            "Error fetching receiving plant IDs and storage locations:",
            err
          );
          setAllReceivingPlants([]);
          setPlantList([]);
          setPlantIdOptions([]);
        }
      });

    // Fetch Brand options - same as PO Dashboard
    axios
      .get(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchBrandValues`
      )
      .then((res) => {
        if (res.data?.status) {
          const brands = res.data?.data ? res.data?.data : [];
          setBrandList(brands);
          setBrandOptions(brands);
        }
      })
      .catch((err) => {
        console.error(err);
      });

    // Fetch Planner options - same as PO Dashboard
    axios
      .get(`${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchPlannerDetailsDirect`)
      .then((res) => {
        if (res.data?.status) {
          setPlannerOptions(res.data?.data ? res.data?.data : []);
          setPlannerList(res.data?.data ? res.data?.data : []);
        }
      })
      .catch((err) => {
        console.error(err);
      });

    // Fetch MFG plants - same as PO Dashboard
    axios
      .get(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchMfgPlants`
      )
      .then((res) => {
        if (res.data?.status) {
          const plants = res.data?.MfgPlantsDetails ? res.data?.MfgPlantsDetails : [];
          setMFGPlantList(plants);
          setOriginalMfgPlantList(plants);
        } else {
          setMFGPlantList([]);
          setOriginalMfgPlantList([]);
        }
      })
      .catch((err) => {
        console.error("Error fetching MFG plants:", err);
        setMFGPlantList([]);
        setOriginalMfgPlantList([]);
      });

    // Fetch Product Type options using fetchProductTypes API with true
    axios
      .get(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchProductTypes/true`
      )
      .then((res) => {
        if (res.data?.data?.status) {
          const productTypeList = res.data?.data?.productTypeList || [];
          setProductTypeOptions(productTypeList);
          setOriginalProductTypeOptions(productTypeList);
        }
      })
      .catch((err) => {
        console.error("Error fetching product types:", err);
      });


    return () => {
      isMounted = false; // Cleanup to prevent memory leaks

      dispatch({
        type: FETCH_PURCHASE_ORDER_FILTER,
        payload: { status: false }
      });
    };
  }, [dispatch]);

  useEffect(() => {
    if (purchaseOrderFilter && purchaseOrderFilter.hasOwnProperty('status') &&
      JSON.stringify(purchaseOrderFilter) !== JSON.stringify(previousFilters.current)) {

      const savedFilterData =
        purchaseOrderFilter?.save_filter_options &&
          typeof purchaseOrderFilter?.save_filter_options === "object"
          ? purchaseOrderFilter.save_filter_options
          : {};

      setSavedFilter(savedFilterData);
      previousFilters.current = purchaseOrderFilter;
    }
  }, [purchaseOrderFilter]);

  useEffect(() => {
    if (filtersLoadedFromAPI) {
      previousApiFilters.current = {};
      hasMadeFirstAPICall.current = false; // Reset so first API call after filters load is allowed
    }
  }, [filtersLoadedFromAPI]);

  const debouncedFetchInactivePOs = useMemo(
    () =>
      debounce((filters, dispatch) => {

        hasMadeFirstAPICall.current = true; // Mark that we've actually made the API call
        setLoading(true);
        dispatch({
          type: FETCH_PURCHASE_ORDER_LOADING,
          payload: true,
        });

        dispatch(fetchInActivePurchaseOrders(filters))
          .then((response) => {
            if (response?.status) {
              const responseData = response.data?.inactivePODetailsList || [];
              setPoData(Array.isArray(responseData) ? responseData : []);
              setTotalPages(response.data?.numberOfPages || 1);
              setLastSynced(new Date());
            } else {
              setPoData([]);
              setTotalPages(1);
            }
            setLoading(false);
            dispatch({
              type: FETCH_PURCHASE_ORDER_LOADING,
              payload: false,
            });
          })
          .catch((error) => {
            console.error("Error fetching inactive POs:", error);
            setPoData([]);
            setTotalPages(1);
            setLoading(false);
            dispatch({
              type: FETCH_PURCHASE_ORDER_LOADING,
              payload: false,
            });
          });
      }, 500),
    [dispatch]
  );

  // Apply saved filters when loaded and trigger API call (same as PO Dashboard)
  useEffect(() => {

    if (!tokenData?.organization_id) {
      return;
    }

    if (!filtersLoadedFromAPI) {
      return;
    }

    if (savedFilter === undefined) {
      return;
    }


    const normalizedSearchValue =
      searchValue === null || searchValue === undefined ||
        searchValue === "" || (Array.isArray(searchValue) && searchValue.length === 0)
        ? null
        : searchValue;

    // Prepare market values for API
    let marketValuesForAPI = null;
    if (searchField === "Market" && selectedMarkets.length > 0) {
      marketValuesForAPI = selectedMarkets.flatMap(market => market.marketorder_be || []);
    }

    // Prepare region codes for API
    let regionCodesForAPI = null;
    if (searchField === "Region" && selectedRegions.length > 0) {
      regionCodesForAPI = selectedRegions.map(region => region.regionCode);
    }

    const poStatusParams = getPOStatusFilterParams();

    const isSearchFieldAll = searchField === "all" ||
      (searchField === "PO Status" && selectedPOStatuses.length === 0) ||
      (searchField === "Market" && selectedMarkets.length === 0) ||
      (searchField === "Region" && selectedRegions.length === 0) ||
      (searchField === "PO-Level Reason Code" && selectedPoLevelReasonCodes.length === 0);

    // Detect savedFilter change early so stat dates can be resolved before currentFilters is built
    const savedFilterChangedEarly = JSON.stringify(previousSavedFilter.current) !== JSON.stringify(savedFilter);

    // When savedFilter itself changes, use its stat date values; otherwise use current state
    const savedStatDateFrom = savedFilter?.poStatDateStart ? moment.utc(savedFilter.poStatDateStart).startOf('day') : null;
    const savedStatDateTo = savedFilter?.poStatDateEnd ? moment.utc(savedFilter.poStatDateEnd).endOf('day') : null;
    const effectiveStatDateFrom = savedFilterChangedEarly ? savedStatDateFrom : poStatDateStart;
    const effectiveStatDateTo = savedFilterChangedEarly ? savedStatDateTo : poStatDateEnd;

    const currentFilters = {
      searchField: isSearchFieldAll ? "all" : searchField,
      searchValue: searchField === "PO Status"
        ? poStatusParams.searchValue
        : (isSearchFieldAll || searchField === "Market" || searchField === "Region" || searchField === "PO-Level Reason Code"
          ? null
          : normalizedSearchValue),
      viewPOOption: selectedAction === "View all PO" ? "all" : selectedAction,
      poStatDateStart: effectiveStatDateFrom ? effectiveStatDateFrom.toISOString() : null,
      poStatDateEnd: effectiveStatDateTo ? effectiveStatDateTo.toISOString() : null,
      plantCodeList: filteredPlantList.length > 0 ? filteredPlantList : [],
      vendorMosymphonyIDList: SelectedCMOList.length > 0 ? SelectedCMOList : (filteredVendorMosymphonyIDList.length > 0 ? filteredVendorMosymphonyIDList : []),
      pageNumber: currentPage,
      pageSize: rowsPerPage,
      plannerSaasUserIDs: selectedPlannerList.length > 0 ? selectedPlannerList : [],
      brand: selectedBrandList.length > 0 ? selectedBrandList : [],
      productTypeIDs: selectedProductType.length > 0 ? selectedProductType : [],

      poStatusIDList: poStatusParams.poStatusIDList,

      marketValues: isSearchFieldAll || searchField !== "Market" || selectedMarkets.length === 0 ? null : marketValuesForAPI,

      regionCodes: isSearchFieldAll || searchField !== "Region" || selectedRegions.length === 0 ? null : regionCodesForAPI,

      poLevelReasonCodes: isSearchFieldAll || searchField !== "PO-Level Reason Code" || selectedPoLevelReasonCodes.length === 0
        ? []
        : selectedPoLevelReasonCodes.map(r => r.reasonCode || r),
    };


    const isPreviousFiltersEmpty = !previousApiFilters.current || Object.keys(previousApiFilters.current).length === 0;


    const currentUserType = localStorage.collabType || 'Unknown';



    const pageNumberChanged = previousApiFilters.current &&
      previousApiFilters.current.pageNumber !== undefined &&
      previousApiFilters.current.pageNumber !== currentFilters.pageNumber;

    const pageSizeChanged = previousApiFilters.current &&
      previousApiFilters.current.pageSize !== undefined &&
      previousApiFilters.current.pageSize !== currentFilters.pageSize;

    if (pageNumberChanged || pageSizeChanged) {

      const paginationFilters = {
        ...currentFilters,
        plantCodeList: filteredPlantList.length > 0 ? filteredPlantList : [],
        vendorMosymphonyIDList: SelectedCMOList.length > 0 ? SelectedCMOList : (filteredVendorMosymphonyIDList.length > 0 ? filteredVendorMosymphonyIDList : []),
        plannerSaasUserIDs: selectedPlannerList.length > 0 ? selectedPlannerList : [],
        brand: selectedBrandList.length > 0 ? selectedBrandList : [],
        productTypeIDs: selectedProductType.length > 0 ? selectedProductType : [],

      };

      previousApiFilters.current = paginationFilters;

      debouncedFetchInactivePOs(paginationFilters, dispatch);
      return;
    }


    const filtersWithoutSearch = {
      searchField: searchField,
      viewPOOption: currentFilters.viewPOOption,
      poStatDateStart: currentFilters.poStatDateStart,
      poStatDateEnd: currentFilters.poStatDateEnd,
      plantCodeList: currentFilters.plantCodeList,
      vendorMosymphonyIDList: currentFilters.vendorMosymphonyIDList,
      pageNumber: currentFilters.pageNumber,
      pageSize: currentFilters.pageSize,
      plannerSaasUserIDs: currentFilters.plannerSaasUserIDs,
      brand: currentFilters.brand,
      productTypeIDs: currentFilters.productTypeIDs,
      searchValue: previousApiFilters.current?.searchValue || null, // Use previous searchValue for comparison
    };
    // This ensures comparison works when unchecking all checkboxes
    const previousSearchFieldForComparison = previousApiFilters.current?.searchField === "all"
      ? searchField // Use current state searchField if previous was "all"
      : (previousApiFilters.current?.searchField || searchField);
    const previousFiltersWithoutSearch = previousApiFilters.current ? {
      searchField: previousSearchFieldForComparison,
      viewPOOption: previousApiFilters.current.viewPOOption,
      poStatDateStart: previousApiFilters.current.poStatDateStart,
      poStatDateEnd: previousApiFilters.current.poStatDateEnd,
      plantCodeList: previousApiFilters.current.plantCodeList,
      vendorMosymphonyIDList: previousApiFilters.current.vendorMosymphonyIDList,
      pageNumber: previousApiFilters.current.pageNumber,
      pageSize: previousApiFilters.current.pageSize,
      plannerSaasUserIDs: previousApiFilters.current.plannerSaasUserIDs,
      brand: previousApiFilters.current.brand,
      productTypeIDs: previousApiFilters.current.productTypeIDs,
      searchValue: previousApiFilters.current.searchValue || null,
    } : null;

    const checkboxFieldsChanged = previousApiFilters.current ? {
      poStatusIDList_changed: JSON.stringify(previousApiFilters.current.poStatusIDList) !== JSON.stringify(currentFilters.poStatusIDList),
      marketValues_changed: JSON.stringify(previousApiFilters.current.marketValues) !== JSON.stringify(currentFilters.marketValues),
      regionCodes_changed: JSON.stringify(previousApiFilters.current.regionCodes) !== JSON.stringify(currentFilters.regionCodes),
      poLevelReasonCodes_changed: JSON.stringify(previousApiFilters.current.poLevelReasonCodes) !== JSON.stringify(currentFilters.poLevelReasonCodes),
    } : { all_new: true };

    const filtersMatch = !isPreviousFiltersEmpty &&
      hasMadeFirstAPICall.current &&
      previousFiltersWithoutSearch &&
      JSON.stringify(previousFiltersWithoutSearch) === JSON.stringify(filtersWithoutSearch);




    if (
      !isPreviousFiltersEmpty &&
      hasMadeFirstAPICall.current &&
      previousFiltersWithoutSearch &&
      JSON.stringify(previousFiltersWithoutSearch) === JSON.stringify(filtersWithoutSearch)
    ) {

      // Update searchValue and checkbox fields in previousApiFilters to track them, but don't call API
      if (previousApiFilters.current) {
        previousApiFilters.current.searchValue = currentFilters.searchValue;
        previousApiFilters.current.poStatusIDList = currentFilters.poStatusIDList;
        previousApiFilters.current.marketValues = currentFilters.marketValues;
        previousApiFilters.current.regionCodes = currentFilters.regionCodes;
        previousApiFilters.current.poLevelReasonCodes = currentFilters.poLevelReasonCodes;
      }
      return;
    }


    previousApiFilters.current = currentFilters;

    const savedFilterChanged = savedFilterChangedEarly;

    if (savedFilterChanged) {
      const plantList = Array.isArray(savedFilter?.plantListFilter)
        ? savedFilter?.plantListFilter
        : [];
      const cmoList = Array.isArray(savedFilter?.cmoListFilter)
        ? savedFilter?.cmoListFilter
        : [];
      const plannerList = Array.isArray(savedFilter?.plannerUserId)
        ? savedFilter?.plannerUserId
        : [];
      const brandList = Array.isArray(savedFilter?.brand)
        ? savedFilter?.brand
        : [];
      const productTypeList = Array.isArray(savedFilter?.productType)
        ? savedFilter?.productType
        : [];
      const savedMfgPlantList = Array.isArray(savedFilter?.mfgPlantListFilter)
        ? savedFilter?.mfgPlantListFilter
        : [];

      if (JSON.stringify(selectedPlantIdList) !== JSON.stringify(plantList)) {
        setSelectedPlantIdList(plantList);
      }
      if (JSON.stringify(SelectedCMOList) !== JSON.stringify(cmoList)) {
        setSelectedCMOList(cmoList);
        setSelectedCMOs(cmoList);
      }
      if (JSON.stringify(selectedPlannerList) !== JSON.stringify(plannerList)) {
        setSelectedPlannerList(plannerList);
        setSelectedPlanners(plannerList);
      }
      if (JSON.stringify(selectedBrandList) !== JSON.stringify(brandList)) {
        setSelectedBrandList(brandList);
        setSelectedBrands(brandList);
      }
      if (JSON.stringify(selectedProductType) !== JSON.stringify(productTypeList)) {
        setSelectedProductType(productTypeList);
      }
      if (JSON.stringify(selectedMFGPlantList) !== JSON.stringify(savedMfgPlantList)) {
        setSelectedMFGPlantList(savedMfgPlantList);
      }
      if (JSON.stringify(filteredPlantList) !== JSON.stringify(plantList)) {
        setFilteredPlantList(plantList);
      }
      if (
        JSON.stringify(filteredVendorMosymphonyIDList) !== JSON.stringify(cmoList)
      ) {
        setFilteredVendorMosymphonyIDList(cmoList);
      }

      // Restore stat dates from savedFilter for UI
      setPoStatDateStart(savedStatDateFrom);
      setPoStatDateEnd(savedStatDateTo);

      // Update previous savedFilter ref
      previousSavedFilter.current = savedFilter;
    }


    if (cmoMemberWithId && cmoMemberWithId.length > 0 && savedFilter?.cmoListFilter) {
      const savedCmoList = Array.isArray(savedFilter.cmoListFilter) ? savedFilter.cmoListFilter : [];
      const normalizedSavedCmoList = savedCmoList.map(id => Number(id)).sort();
      const normalizedSelectedCmoList = SelectedCMOList.map(id => Number(id)).sort();

      if (savedCmoList.length > 0 &&
        JSON.stringify(normalizedSavedCmoList) !== JSON.stringify(normalizedSelectedCmoList)) {
        setSelectedCMOList(savedCmoList);
        setSelectedCMOs(savedCmoList);
        setFilteredVendorMosymphonyIDList(savedCmoList);
      }
    }


    if (
      JSON.stringify(previousVendorList.current) !== JSON.stringify(filteredVendorMosymphonyIDList)
    ) {
      previousVendorList.current = filteredVendorMosymphonyIDList;
    }
    if (
      JSON.stringify(previousPlantList.current) !== JSON.stringify(filteredPlantList)
    ) {
      previousPlantList.current = filteredPlantList;
    }
    if (
      JSON.stringify(previousPlannerList.current) !==
      JSON.stringify(selectedPlannerList)
    ) {
      previousPlannerList.current = selectedPlannerList;
    }
    if (
      JSON.stringify(previousBrandList.current) !== JSON.stringify(selectedBrandList)
    ) {
      previousBrandList.current = selectedBrandList;
    }
    if (
      JSON.stringify(previousProductTypeList.current) !== JSON.stringify(selectedProductType)
    ) {
      previousProductTypeList.current = selectedProductType;
    }

    // Call main dashboard API with savedFilter values directly (same as PO Dashboard)
    debouncedFetchInactivePOs(currentFilters, dispatch);

    return () => {
      debouncedFetchInactivePOs.cancel();
    };
  }, [
    savedFilter,
    tokenData?.organization_id,
    currentPage,
    rowsPerPage,
    debouncedFetchInactivePOs,
    dispatch,
    filtersLoadedFromAPI,
    cmoMemberWithId,
  ]);



  const fetchInactivePOs = async () => {

    setLoading(true);
    dispatch({
      type: FETCH_PURCHASE_ORDER_LOADING,
      payload: true,
    });

    try {
      // Prepare request payload for inactive POs - same as PO Dashboard
      // Prepare market values for API
      let marketValuesForAPI = null;
      if (searchField === "Market" && selectedMarkets.length > 0) {
        marketValuesForAPI = selectedMarkets.flatMap(market => market.marketorder_be || []);
      }

      // Prepare region codes for API
      let regionCodesForAPI = null;
      if (searchField === "Region" && selectedRegions.length > 0) {
        regionCodesForAPI = selectedRegions.map(region => region.regionCode);
      }

      // Determine if searchField is "all"
      const isSearchFieldAll = searchField === "all" ||
        (searchField === "PO Status" && selectedPOStatuses.length === 0) ||
        (searchField === "Market" && selectedMarkets.length === 0) ||
        (searchField === "Region" && selectedRegions.length === 0) ||
        (searchField === "PO-Level Reason Code" && selectedPoLevelReasonCodes.length === 0);

      const poStatusParams = getPOStatusFilterParams();


      const plantCodeListForAPI = isSearchFieldAll ? [] : (filteredPlantList.length > 0 ? filteredPlantList : []);
      const vendorMosymphonyIDListForAPI = isSearchFieldAll ? [] : (filteredVendorMosymphonyIDList.length > 0 ? filteredVendorMosymphonyIDList : []);
      const plannerSaasUserIDsForAPI = isSearchFieldAll ? [] : (selectedPlannerList.length > 0 ? selectedPlannerList : []);
      const brandForAPI = isSearchFieldAll ? [] : (selectedBrandList.length > 0 ? selectedBrandList : []);
      const productTypeIDsForAPI = isSearchFieldAll ? [] : (selectedProductType.length > 0 ? selectedProductType : []);

      const requestParams = {
        searchField: isSearchFieldAll ? "all" : searchField,
        searchValue: searchField === "PO Status"
          ? poStatusParams.searchValue
          : (isSearchFieldAll || searchField === "Market" || searchField === "Region" || searchField === "PO-Level Reason Code"
            ? null
            : (searchValue ? searchValue.trim() : null)),
        viewPOOption: selectedAction === "View all PO" ? "all" : selectedAction,
        poStatDateStart: poStatDateStart ? poStatDateStart.toISOString() : null,
        poStatDateEnd: poStatDateEnd ? poStatDateEnd.toISOString() : null,
        plantCodeList: plantCodeListForAPI,
        vendorMosymphonyIDList: vendorMosymphonyIDListForAPI,
        pageNumber: currentPage,
        pageSize: rowsPerPage,
        plannerSaasUserIDs: plannerSaasUserIDsForAPI,
        brand: brandForAPI,
        productTypeIDs: productTypeIDsForAPI,
        aslNumberList: selectedMFGPlantList,
        // Use helper function to properly set poStatusIDList
        poStatusIDList: poStatusParams.poStatusIDList,
        marketValues: isSearchFieldAll || searchField !== "Market" || selectedMarkets.length === 0 ? null : marketValuesForAPI,
        regionCodes: isSearchFieldAll || searchField !== "Region" || selectedRegions.length === 0 ? null : regionCodesForAPI,
        poLevelReasonCodes: isSearchFieldAll || searchField !== "PO-Level Reason Code" || selectedPoLevelReasonCodes.length === 0
          ? []
          : selectedPoLevelReasonCodes.map(r => r.reasonCode || r),
      };

      const response = await dispatch(
        fetchInActivePurchaseOrders(requestParams)
      );

      if (response?.status) {
        // Handle new response structure with inactivePODetailsList
        const responseData = response.data?.inactivePODetailsList || [];
        setPoData(Array.isArray(responseData) ? responseData : []);
        setTotalPages(response.data?.numberOfPages || 1);
        setLastSynced(new Date());


        if (previousVendorList.current.length === 0 && previousPlantList.current.length === 0 &&
          previousPlannerList.current.length === 0 && previousBrandList.current.length === 0 &&
          previousProductTypeList.current.length === 0 && previousMfgPlantList.current.length === 0) {
          previousVendorList.current = [...SelectedCMOList];
          previousPlantList.current = [...selectedPlantIdList];
          previousPlannerList.current = [...selectedPlannerList];
          previousBrandList.current = [...selectedBrandList];
          previousProductTypeList.current = [...selectedProductType];
          previousMfgPlantList.current = [...selectedMFGPlantList];
        }
      } else {
        console.warn("API response status is false:", response);
        setTotalPages(1);
      }
    } catch (error) {
      console.error("Error fetching inactive POs:", error);
      setTotalPages(1);
    } finally {
      setLoading(false);
      dispatch({
        type: FETCH_PURCHASE_ORDER_LOADING,
        payload: false,
      });
    }
  };



  // Handle rows per page change - same as PO Dashboard (directly calls API)
  const handleRowsPerPageChange = (event) => {
    const newRowsPerPage = event.target.value;
    setRowsPerPage(newRowsPerPage);
    setCurrentPage(1); // Reset to first page
    setLoading(true); // Set local loading state

    // Prepare market values for API
    let marketValuesForAPI = null;
    if (searchField === "Market" && selectedMarkets.length > 0) {
      marketValuesForAPI = selectedMarkets.flatMap(market => market.marketorder_be || []);
    }

    // Prepare region codes for API
    let regionCodesForAPI = null;
    if (searchField === "Region" && selectedRegions.length > 0) {
      regionCodesForAPI = selectedRegions.map(region => region.regionCode);
    }

    // Determine if searchField is "all"
    const isSearchFieldAll = searchField === "all" ||
      (searchField === "PO Status" && selectedPOStatuses.length === 0) ||
      (searchField === "Market" && selectedMarkets.length === 0) ||
      (searchField === "Region" && selectedRegions.length === 0) ||
      (searchField === "PO-Level Reason Code" && selectedPoLevelReasonCodes.length === 0);

    // Get PO Status filter params using helper function
    const poStatusParams = getPOStatusFilterParams();


    const plantCodeListForAPI = filteredPlantList.length > 0 ? filteredPlantList : [];
    const vendorMosymphonyIDListForAPI = filteredVendorMosymphonyIDList.length > 0 ? filteredVendorMosymphonyIDList : [];
    const plannerSaasUserIDsForAPI = selectedPlannerList.length > 0 ? selectedPlannerList : [];
    const brandForAPI = selectedBrandList.length > 0 ? selectedBrandList : [];
    const productTypeIDsForAPI = selectedProductType.length > 0 ? selectedProductType : [];

    dispatch({
      type: FETCH_PURCHASE_ORDER_LOADING,
      payload: true,
    });

    const requestParams = {
      searchField: isSearchFieldAll ? "all" : searchField,
      searchValue: searchField === "PO Status"
        ? poStatusParams.searchValue
        : (isSearchFieldAll || searchField === "Market" || searchField === "Region" || searchField === "PO-Level Reason Code"
          ? null
          : (searchValue ? searchValue.trim() : null)),
      viewPOOption: selectedAction === "View all PO" ? "all" : selectedAction,
      poStatDateStart: poStatDateStart ? poStatDateStart.toISOString() : null,
      poStatDateEnd: poStatDateEnd ? poStatDateEnd.toISOString() : null,
      plantCodeList: plantCodeListForAPI,
      vendorMosymphonyIDList: vendorMosymphonyIDListForAPI,
      pageNumber: 1,
      pageSize: newRowsPerPage,
      plannerSaasUserIDs: plannerSaasUserIDsForAPI,
      brand: brandForAPI,
      productTypeIDs: productTypeIDsForAPI,
      aslNumberList: selectedMFGPlantList,
      poStatusIDList: poStatusParams.poStatusIDList,
      marketValues: isSearchFieldAll || searchField !== "Market" || selectedMarkets.length === 0 ? null : marketValuesForAPI,
      regionCodes: isSearchFieldAll || searchField !== "Region" || selectedRegions.length === 0 ? null : regionCodesForAPI,
      poLevelReasonCodes: isSearchFieldAll || searchField !== "PO-Level Reason Code" || selectedPoLevelReasonCodes.length === 0
        ? []
        : selectedPoLevelReasonCodes.map(r => r.reasonCode || r),
    };

    dispatch(fetchInActivePurchaseOrders(requestParams))
      .then((response) => {
        if (response?.status) {
          const responseData = response.data?.inactivePODetailsList || [];
          setPoData(Array.isArray(responseData) ? responseData : []);
          setTotalPages(response.data?.numberOfPages || 1);
          setLastSynced(new Date());
        } else {
          setTotalPages(1);
        }
      })
      .catch((error) => {
        console.error("Error fetching inactive POs on rows per page change:", error);
        setTotalPages(1);
      })
      .finally(() => {
        setLoading(false); // Clear local loading state
        dispatch({
          type: FETCH_PURCHASE_ORDER_LOADING,
          payload: false,
        });
      });
  };


  const getPOStatusFilterParams = () => {
    if (searchField !== "PO Status" || selectedPOStatuses.length === 0) {
      return { poStatusIDList: null, searchValue: null };
    }

    // Convert status_id to number for reliable comparison
    const hasCancelled = selectedPOStatuses.some(status => {
      const statusId = Number(status.status_id);
      return statusId === 0;
    });
    const hasDeliveryComplete = selectedPOStatuses.some(status => {
      const statusId = Number(status.status_id);
      return statusId === 30;
    });

    if (hasCancelled && hasDeliveryComplete) {
      return { poStatusIDList: [30], searchValue: "Cancelled" };
    } else if (hasCancelled) {
      return { poStatusIDList: [], searchValue: "Cancelled" };
    } else if (hasDeliveryComplete) {

      return { poStatusIDList: [30], searchValue: null };
    } else {
      const otherStatusIds = selectedPOStatuses
        .map(status => Number(status.status_id))
        .filter(id => id !== 0 && id !== 30);
      return {
        poStatusIDList: otherStatusIds.length > 0 ? otherStatusIds : null,
        searchValue: null
      };
    }
  };


  const handlePageChange = (newPage) => {

    setCurrentPage(newPage);
  };

  // Helper functions - same as PO Dashboard
  const uniqueBrandOptions = Array.isArray(brandList)
    ? brandList.map((item) =>
      typeof item === "string" ? { brand: item } : item
    )
    : [];

  // Optimized comparison function - faster than JSON.stringify
  const arraysEqual = useCallback((a, b) => {
    if (a.length !== b.length) return false;
    const sortedA = [...a].sort();
    const sortedB = [...b].sort();
    for (let i = 0; i < sortedA.length; i++) {
      if (sortedA[i] !== sortedB[i]) return false;
    }
    return true;
  }, []);

  // Pre-compute available CMOs once per render for better performance
  const availableCMOs = useMemo(() => {
    let list = cmoMemberWithId || [];

    // Filter by planner selection first
    if (selectedPlannerList.length > 0 && !selectedPlannerList.includes("All")) {
      list = list.filter((option) => {
        return selectedPlannerList.some((plannerId) => {
          const planner = plannerList.find((p) => p.saasUserID === plannerId);
          return (
            planner &&
            planner.organization_ids &&
            planner.organization_ids.includes(option.organization_id)
          );
        });
      });
    }

    // Filter by MFG plant selection
    if (selectedMFGPlantList.length > 0 && !selectedMFGPlantList.includes("All")) {
      const selectedPlantVendorIds = selectedMFGPlantList.flatMap((aslNumber) => {
        const plant = mfgPlantList.find((p) => p.aslNumber === aslNumber);
        return plant ? [plant.vendorMosymphonyID] : [];
      });

      list = list.filter((cmo) =>
        selectedPlantVendorIds.includes(cmo.organization_id)
      );
    }

    // Filter by plant selection
    if (selectedPlantIdList.length > 0 && !selectedPlantIdList.includes("All")) {
      // Get all vendorMosymphonyIDs from selected plants (including all associated vendors)
      const selectedPlantVendorIds = selectedPlantIdList.flatMap((plantCode) => {
        const plant = allReceivingPlants.find((p) => p.plantCode === plantCode);
        return plant
          ? plant.allVendorMosymphonyIDs || [plant.vendorMosymphonyID]
          : [];
      });

      // Filter CMOs to only show those associated with selected plants
      list = list.filter((cmo) =>
        selectedPlantVendorIds.includes(cmo.organization_id)
      );
    }

    // Filter by product type selection
    if (selectedProductType.length > 0) {
      list = list.filter((cmo) => {
        if (!Array.isArray(cmo.productTypeIDs) || cmo.productTypeIDs.length === 0) {
          return false;
        }

        // Check if CMO has at least one of the selected product types
        return selectedProductType.some((selectedProductTypeID) => {
          const numSelectedId = typeof selectedProductTypeID === 'string'
            ? parseInt(selectedProductTypeID, 10)
            : Number(selectedProductTypeID);

          // Check if this product type ID exists in CMO's productTypeIDs array
          return cmo.productTypeIDs.some((cmoProductTypeID) => {
            const numCmoId = typeof cmoProductTypeID === 'string'
              ? parseInt(cmoProductTypeID, 10)
              : Number(cmoProductTypeID);
            return !isNaN(numSelectedId) && !isNaN(numCmoId) && numSelectedId === numCmoId;
          });
        });
      });
    }

    return list;
  }, [
    cmoMemberWithId,
    selectedPlannerList,
    plannerList,
    selectedMFGPlantList,
    mfgPlantList,
    selectedPlantIdList,
    allReceivingPlants,
    selectedProductType,
  ]);

  // Filter product types when CMO selection changes (including from saved filters)
  useEffect(() => {
    // Only filter if we have both CMO data and product type options loaded
    if (!cmoMemberWithId || cmoMemberWithId.length === 0 || originalProductTypeOptions.length === 0) {
      return;
    }

    // Filter product types based on selected CMO's productTypeID
    if (SelectedCMOList.length === 0) {
      setProductTypeOptions(originalProductTypeOptions);
    } else {
      const selectedCMOObjects = cmoMemberWithId.filter(cmo =>
        SelectedCMOList.includes(cmo.organization_id)
      );

      const productTypeIDs = new Set();
      selectedCMOObjects.forEach(cmo => {
        // API returns productTypeIDs as an array
        if (Array.isArray(cmo.productTypeIDs) && cmo.productTypeIDs.length > 0) {
          cmo.productTypeIDs.forEach(id => {
            if (id === null || id === undefined || id === '') {
              return;
            }
            // Convert to number consistently
            const numId = typeof id === 'string' ? parseInt(id, 10) : Number(id);
            // Only add valid numbers
            if (!isNaN(numId) && isFinite(numId)) {
              productTypeIDs.add(numId);
            }
          });
        }
      });

      if (productTypeIDs.size > 0) {
        const filteredProductTypes = originalProductTypeOptions.filter(productType => {
          // Skip if productTypeID is missing
          if (productType.productTypeID === undefined || productType.productTypeID === null) {
            return false;
          }
          // Convert to number consistently for comparison
          const productTypeId = typeof productType.productTypeID === 'string'
            ? parseInt(productType.productTypeID, 10)
            : Number(productType.productTypeID);
          if (isNaN(productTypeId) || !isFinite(productTypeId)) {
            return false;
          }
          return productTypeIDs.has(productTypeId);
        });
        setProductTypeOptions(filteredProductTypes);

        if (selectedProductType.length > 0) {
          const availableProductTypeIDs = filteredProductTypes.map(pt => pt.productTypeID);
          const filteredSelectedProductTypes = selectedProductType.filter(productTypeID =>
            availableProductTypeIDs.includes(productTypeID)
          );
          if (JSON.stringify(filteredSelectedProductTypes.sort()) !== JSON.stringify(selectedProductType.sort())) {
            setSelectedProductType(filteredSelectedProductTypes);
          }
        }
      } else {

        setProductTypeOptions(originalProductTypeOptions);

        if (selectedProductType.length > 0) {
          setSelectedProductType([]);
        }
      }
    }
  }, [SelectedCMOList, cmoMemberWithId, originalProductTypeOptions]);

  useEffect(() => {
    if (!cmoMemberWithId || cmoMemberWithId.length === 0) {
      return;
    }

    if (selectedProductType.length > 0) {
      const validCMOIds = availableCMOs.map(cmo => cmo.organization_id);

      // Remove any selected CMOs that are no longer available after product type filtering
      if (SelectedCMOList.length > 0) {
        const filteredCMOList = SelectedCMOList.filter(cmoId =>
          validCMOIds.includes(cmoId)
        );

        if (JSON.stringify(filteredCMOList.sort()) !== JSON.stringify(SelectedCMOList.sort())) {
          setSelectedCMOList(filteredCMOList);
        }
      }
    }

  }, [selectedProductType, availableCMOs]);

  const getDisplayCMOFilterValue = () => {

    if (!cmoMemberWithId || cmoMemberWithId.length === 0) {
      return "All";
    }

    if (
      SelectedCMOList.length === availableCMOs.length &&
      SelectedCMOList.length !== 1
    ) {
      return "All";
    } else if (
      SelectedCMOList.length === availableCMOs.length &&
      SelectedCMOList.length === 1
    ) {
      let result = availableCMOs.filter(
        (val) => SelectedCMOList[0] == val.organization_id
      );
      if (result.length > 0) {
        return result[0].organization_name;
      } else {
        return "All";
      }
    } else if (SelectedCMOList.length === 1) {
      let result = availableCMOs.filter(
        (val) => SelectedCMOList[0] == val.organization_id
      );
      if (result.length > 0) {
        return result[0].organization_name;
      } else {
        return "All";
      }
    }
    return "Multiple selection";
  };


  const getDisplayMFGPlantValue = () => {
    if (
      selectedMFGPlantList.length === mfgPlantList.length &&
      selectedMFGPlantList.length !== 1
    )
      return "All";
    else if (
      selectedMFGPlantList.length === mfgPlantList.length &&
      selectedMFGPlantList.length === 1
    ) {
      let result = mfgPlantList.filter(
        (val) => selectedMFGPlantList[0] === val.aslNumber
      );
      if (result.length > 0) {
        return result[0].mfgPlantShortName;
      } else {
        return "All";
      }
    } else if (selectedMFGPlantList.length === 1) {
      let result = mfgPlantList.filter(
        (val) => selectedMFGPlantList[0] === val.aslNumber
      );
      if (result.length > 0) {
        return result[0].mfgPlantShortName;
      } else {
        return "All";
      }
    }
    return "Multiple selection";
  };


  const getDisplayPlantIDValue = () => {
    if (
      selectedPlantIdList.length === plantList.length &&
      selectedPlantIdList.length !== 1
    )
      return "All";
    else if (
      selectedPlantIdList.length === plantList.length &&
      selectedPlantIdList.length === 1
    ) {
      let result = plantList.filter(
        (val) => selectedPlantIdList[0] == val.plantCode
      );
      if (result.length > 0) {
        return result[0].plantCode;
      } else {
        return "All";
      }
    } else if (selectedPlantIdList.length === 1) {
      let result = plantList.filter(
        (val) => selectedPlantIdList[0] == val.plantCode
      );
      if (result.length > 0) {
        return result[0].plantCode;
      } else {
        return "All";
      }
    }
    return "Multiple selection";
  };

  const getDisplayPlannerValue = () => {
    if (
      selectedPlannerList.length === plannerList.length &&
      selectedPlannerList.length !== 1
    )
      return "All";
    else if (
      selectedPlannerList.length === plannerList.length &&
      selectedPlannerList.length === 1
    ) {
      let result = plannerList.filter(
        (val) => selectedPlannerList[0] == val.saasUserID
      );
      if (result.length > 0) {
        return result[0].name;
      } else {
        return "All";
      }
    } else if (selectedPlannerList.length === 1) {
      let result = plannerList.filter(
        (val) => selectedPlannerList[0] == val.saasUserID
      );
      if (result.length > 0) {
        return result[0].name;
      } else {
        return "All";
      }
    }
    return "Multiple selection";
  };

  const getDisplayBrandValue = () => {
    if (
      selectedBrandList.length === uniqueBrandOptions.length &&
      selectedBrandList.length !== 1
    ) {
      return "All";
    } else if (selectedBrandList.length === 1) {
      const brand = uniqueBrandOptions.find(
        (option) => option.brand === selectedBrandList[0]
      );
      if (!brand) return "All";
      return brand.brand
        .toLowerCase()
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
    }
    return selectedBrandList.length > 0 ? "Multiple selection" : "All";
  };

  // Handler functions - same as PO Dashboard (optimized version from main PO dashboard)
  const handleChangeCMOList = (event) => {
    const value = event.target.value;

    let newCMOList = [];
    let filteredPlants = [];
    let filteredMfgPlants = [];

    if (value.includes("All")) {
      newCMOList =
        SelectedCMOList.length === availableCMOs.length
          ? []
          : availableCMOs.map((val) => val.organization_id);

      // Filter plants based on newCMOList
      filteredPlants = allReceivingPlants.filter(
        (val) =>
          newCMOList.length === 0 ||
          newCMOList.some((cmoId) =>
            val.allVendorMosymphonyIDs
              ? val.allVendorMosymphonyIDs.includes(cmoId)
              : val.vendorMosymphonyID === cmoId
          )
      );
      filteredMfgPlants = originalMfgPlantList
    } else {
      newCMOList = value;

      // When no CMOs are selected, show all plants; otherwise filter by selected CMOs
      filteredPlants =
        value.length === 0
          ? allReceivingPlants
          : allReceivingPlants.filter((val) =>
            value.some((cmoId) =>
              val.allVendorMosymphonyIDs
                ? val.allVendorMosymphonyIDs.includes(cmoId)
                : val.vendorMosymphonyID === cmoId
            )
          );

          filteredMfgPlants = value.length === 0 ? originalMfgPlantList : originalMfgPlantList.filter((val) =>
        value.some(cmoId => val.vendorMosymphonyID === cmoId
        ))
    }

    setSelectedCMOList(newCMOList);
    setFilteredVendorMosymphonyIDList(newCMOList);
    setSelectedCMOs(newCMOList);
    setPlantList(filteredPlants);
    setPlantIdOptions(filteredPlants);
    setMFGPlantList(filteredMfgPlants)

    setPlannerList(
      newCMOList.length > 0
        ? plannerOptions.filter(
          (planner) =>
            planner.organization_ids &&
            planner.organization_ids.some((orgId) => newCMOList.includes(orgId))
        )
        : plannerOptions
    );

    // Update selected plants to only include those associated with the new CMO list
    if (selectedPlantIdList.length > 0) {
      setSelectedPlantIdList(
        selectedPlantIdList.filter((plantCode) =>
          filteredPlants.some((plant) => plant.plantCode === plantCode)
        )
      );
      setFilteredPlantList(
        selectedPlantIdList.filter((plantCode) =>
          filteredPlants.some((plant) => plant.plantCode === plantCode)
        )
      );
    } else {
      setSelectedPlantIdList([]);
      setFilteredPlantList([]);
    }
  };

  const handleChangeMFGPlantList = (event) => {
    const value = event.target.value;

    if (value.includes("All")) {
      setSelectedMFGPlantList(
        selectedMFGPlantList.length === mfgPlantList.length
          ? []
          : mfgPlantList.map((val) => val.aslNumber)
      );

      setFilteredVendorMosymphonyIDList([]);
      setPlannerList(plannerOptions);
    } else {
      setSelectedMFGPlantList(value);

      if (value.length > 0) {
        const selectedPlantVendorIds = value.flatMap(aslNumber => {
          const plant = mfgPlantList.find(p => p.aslNumber === aslNumber);
          return plant ? [plant.vendorMosymphonyID] : [];
        });

        const availableCMOsForPlants = cmoMemberWithId.filter(cmo =>
          selectedPlantVendorIds.includes(cmo.organization_id)
        );

        setFilteredVendorMosymphonyIDList([]);

        const availablePlanners = plannerOptions.filter(planner =>
          planner.organization_ids &&
          planner.organization_ids.some(orgId =>
            selectedPlantVendorIds.includes(orgId)
          )
        );

        setPlannerList(availablePlanners);

        if (SelectedCMOList.length > 0) {
          const filteredCMOList = SelectedCMOList.filter(cmoId =>
            availableCMOsForPlants.some(cmo => cmo.organization_id === cmoId)
          );
          setSelectedCMOList(filteredCMOList);
          setSelectedCMOs(filteredCMOList);
        }

        if (selectedPlannerList.length > 0) {
          const filteredPlanners = selectedPlannerList.filter(plannerId =>
            availablePlanners.some(planner => planner.saasUserID === plannerId)
          );
          setSelectedPlannerList(filteredPlanners);
          setSelectedPlanners(filteredPlanners);
        }
      } else {
        setFilteredVendorMosymphonyIDList([]);
        setPlannerList(plannerOptions);
      }
    }

    handleSelectChangeListLosesFocus("mfgPlants", userAssociationData);
  };

  const handleChangePlantIdList = (event) => {
    const value = event.target.value;

    if (value.includes("All")) {
      setSelectedPlantIdList(
        selectedPlantIdList.length === plantList.length
          ? []
          : plantList.map((val) => val.plantCode)
      );


      setFilteredVendorMosymphonyIDList([]);

      // Show all available planners when "All" plants are selected
      setPlannerList(plannerOptions);
    } else {
      setSelectedPlantIdList(value);

      // Filter CMOs and planners based on selected plant IDs
      if (value.length > 0) {
        // Get all vendorMosymphonyIDs from selected plants (including all associated vendors)
        const selectedPlantVendorIds = value.flatMap(plantCode => {
          const plant = allReceivingPlants.find(p => p.plantCode === plantCode);
          return plant ? (plant.allVendorMosymphonyIDs || [plant.vendorMosymphonyID]) : [];
        });

        // Filter CMOs to only show those associated with selected plants
        const availableCMOs = cmoMemberWithId.filter(cmo =>
          selectedPlantVendorIds.includes(cmo.organization_id)
        );


        setFilteredVendorMosymphonyIDList([]);

        // Filter planners to only show those associated with the CMOs of selected plants
        const availablePlanners = plannerOptions.filter(planner =>
          planner.organization_ids &&
          planner.organization_ids.some(orgId =>
            selectedPlantVendorIds.includes(orgId)
          )
        );

        // Update the planner list to show only available planners
        setPlannerList(availablePlanners);

        if (SelectedCMOList.length > 0) {
          setSelectedCMOList(
            SelectedCMOList.filter(cmoId =>
              availableCMOs.some(cmo => cmo.organization_id === cmoId)
            )
          );
          setSelectedCMOs(
            SelectedCMOList.filter(cmoId =>
              availableCMOs.some(cmo => cmo.organization_id === cmoId)
            )
          );
        }


        if (selectedPlannerList.length > 0) {
          setSelectedPlannerList(
            selectedPlannerList.filter(plannerId =>
              availablePlanners.some(planner => planner.saasUserID === plannerId)
            )
          );
          setSelectedPlanners(
            selectedPlannerList.filter(plannerId =>
              availablePlanners.some(planner => planner.saasUserID === plannerId)
            )
          );
        }
      } else {

        setFilteredVendorMosymphonyIDList([]);
        setPlannerList(plannerOptions);

      }
    }

  };

  const handleChangePlannerList = (event) => {
    const selectedPlannerIds = event.target.value;

    setSelectedPlanners(selectedPlannerIds);

    let filteredPlants = [];

    if (selectedPlannerIds.includes("All")) {
      setSelectedPlannerList(
        selectedPlannerList.length === plannerList.length
          ? []
          : plannerList.map((val) => val.saasUserID)
      );
      filteredPlants = allReceivingPlants;
    } else {
      setSelectedPlannerList(selectedPlannerIds);

      const selectedPlanners = plannerList.filter((planner) =>
        selectedPlannerIds.includes(planner.saasUserID)
      );

      if (selectedPlanners.length === 0) {
        filteredPlants = allReceivingPlants;
      } else {
        const availableCMOIds = [
          ...new Set(
            selectedPlanners.flatMap((planner) =>
              planner.organization_ids ? planner.organization_ids : []
            )
          ),
        ];

        filteredPlants = allReceivingPlants.filter((plant) =>
          availableCMOIds.some(cmoId =>
            plant.allVendorMosymphonyIDs ?
              plant.allVendorMosymphonyIDs.includes(cmoId) :
              plant.vendorMosymphonyID === cmoId
          )
        );
      }
    }

    setPlantList(filteredPlants);
    setPlantIdOptions(filteredPlants);

    // Update selected plants to only include those associated with the available CMOs
    if (selectedPlantIdList.length > 0) {
      setSelectedPlantIdList(
        selectedPlantIdList.filter((plantCode) =>
          filteredPlants.some((plant) => plant.plantCode === plantCode)
        )
      );
      setFilteredPlantList(
        selectedPlantIdList.filter((plantCode) =>
          filteredPlants.some((plant) => plant.plantCode === plantCode)
        )
      );
    } else {
      setSelectedPlantIdList([]);
      setFilteredPlantList([]);
    }
  };

  const handleChangeBrandList = (event) => {
    const value = event.target.value;

    if (value.includes("All")) {
      // Toggle between selecting all brands and clearing all
      const allBrands = uniqueBrandOptions.map((option) => option.brand);
      setSelectedBrandList(
        selectedBrandList.length === allBrands.length ? [] : allBrands
      );
      setSelectedBrands(
        selectedBrandList.length === allBrands.length ? [] : allBrands
      );
    } else {
      // Filter out invalid values and "All"
      const filteredValue = value.filter((v) => v !== "All" && v);
      setSelectedBrandList(filteredValue);
      setSelectedBrands(filteredValue);
    }
  };

  const handleSelectChangeListLosesFocus = (type, userAssociations) => {
    setCurrentPage(1);

    let filteredCMO;
    let filteredPlantIds;

    if (type === "cmo") {
      setFilteredVendorMosymphonyIDList(SelectedCMOList);
      filteredCMO = SelectedCMOList.length > 0 ? SelectedCMOList : [];
      filteredPlantIds = selectedPlantIdList.length > 0 ? selectedPlantIdList : [];
    } else if (type === "plantID") {
      setFilteredPlantList(
        selectedPlantIdList.length > 0 ? selectedPlantIdList : []
      );
      filteredCMO = SelectedCMOList.length > 0 ? SelectedCMOList : [];
      filteredPlantIds = selectedPlantIdList.length > 0 ? selectedPlantIdList : [];
    } else if (type === "Planner") {
      filteredCMO = SelectedCMOList.length > 0 ? SelectedCMOList : [];
      filteredPlantIds = selectedPlantIdList.length > 0 ? selectedPlantIdList : [];
    } else if (type === "brand") {
      filteredCMO = SelectedCMOList.length > 0 ? SelectedCMOList : [];
      filteredPlantIds = selectedPlantIdList.length > 0 ? selectedPlantIdList : [];
    } else if (type === "mfgPlants") {
      // filteredCMO = SelectedCMOList.length > 0 ? SelectedCMOList : [];
      filteredCMO = selectedMFGPlantList.flatMap(aslNumber => {
        const plant = mfgPlantList.find(p => p.aslNumber === aslNumber);
        return plant ? [plant.vendorMosymphonyID] : [];
      });

      if(filteredCMO.length !== 0){
        setSelectedCMOList(filteredCMO);
      }
      filteredPlantIds = selectedPlantIdList.length > 0 ? selectedPlantIdList : [];
    } else {
      filteredCMO = SelectedCMOList.length > 0 ? SelectedCMOList : [];
      filteredPlantIds = selectedPlantIdList.length > 0 ? selectedPlantIdList : [];
    }

    // Optimized comparison - faster than JSON.stringify
    const filtersChanged =
      !(previousVendorList.current.length === SelectedCMOList.length &&
        arraysEqual(previousVendorList.current, SelectedCMOList)) ||
      !(previousPlantList.current.length === selectedPlantIdList.length &&
        arraysEqual(previousPlantList.current, selectedPlantIdList)) ||
      !(previousPlannerList.current.length === selectedPlannerList.length &&
        arraysEqual(previousPlannerList.current, selectedPlannerList)) ||
      !(previousBrandList.current.length === selectedBrandList.length &&
        arraysEqual(previousBrandList.current, selectedBrandList)) ||
      !(previousMfgPlantList.current.length === selectedMFGPlantList.length &&
        arraysEqual(previousMfgPlantList.current, selectedMFGPlantList)) ||
      (type === "productType" &&
        !(previousProductTypeList.current.length === selectedProductType.length &&
          arraysEqual(previousProductTypeList.current, selectedProductType)));

    if (filtersChanged) {
      // Update previous values
      previousPlannerList.current = [...selectedPlannerList];
      previousPlantList.current = [...selectedPlantIdList];
      previousVendorList.current = [...SelectedCMOList];
      previousBrandList.current = [...selectedBrandList];
      previousMfgPlantList.current = [...selectedMFGPlantList];
      if (type === "productType") {
        previousProductTypeList.current = [...selectedProductType];
      }

      // Call API with updated filters
      setLoading(true);
      dispatch({
        type: FETCH_PURCHASE_ORDER_LOADING,
        payload: true,
      });

      // Prepare market values for API - same as PO Dashboard
      let marketValuesForAPI = null;
      if (searchField === "Market" && selectedMarkets.length > 0) {
        marketValuesForAPI = selectedMarkets.flatMap(market => market.marketorder_be || []);
      }

      // Prepare region codes for API - same as PO Dashboard
      let regionCodesForAPI = null;
      if (searchField === "Region" && selectedRegions.length > 0) {
        regionCodesForAPI = selectedRegions.map(region => region.regionCode);
      }

      // Get PO Status filter params using helper function
      const poStatusParams = getPOStatusFilterParams();

      const requestParams = {
        searchField: searchField === "PO Status" && selectedPOStatuses.length === 0
          ? "all"
          : (searchField === "Market" && selectedMarkets.length === 0)
            ? "all"
            : (searchField === "Region" && selectedRegions.length === 0)
              ? "all"
              : (searchField === "PO-Level Reason Code" && selectedPoLevelReasonCodes.length === 0)
                ? "all"
                : searchField,

        searchValue: searchField === "PO Status"
          ? poStatusParams.searchValue
          : (searchField !== "all" &&
            searchField !== "Market" &&
            searchField !== "Region" &&
            searchField !== "PO-Level Reason Code" &&
            searchValue
            ? searchValue.trim()
            : null),
        viewPOOption: selectedAction === "View all PO" ? "all" : selectedAction,
        poStatDateStart: poStatDateStart ? poStatDateStart.toISOString() : null,
        poStatDateEnd: poStatDateEnd ? poStatDateEnd.toISOString() : null,
        // Use CURRENT STATE values (same as PO Dashboard pattern)
        plantCodeList: filteredPlantIds.length > 0 ? filteredPlantIds : [],
        vendorMosymphonyIDList: filteredCMO.length > 0 ? filteredCMO : [],
        pageNumber: 1,
        pageSize: rowsPerPage,
        plannerSaasUserIDs: selectedPlannerList.length > 0 ? selectedPlannerList : [],
        brand: selectedBrandList.length > 0 ? selectedBrandList : [],
        productTypeIDs: selectedProductType.length > 0 ? selectedProductType : [],
        aslNumberList: selectedMFGPlantList,
        // Use helper function to properly set poStatusIDList
        poStatusIDList: poStatusParams.poStatusIDList,
        marketValues: marketValuesForAPI,
        regionCodes: regionCodesForAPI,
        poLevelReasonCodes: searchField === "PO-Level Reason Code" && selectedPoLevelReasonCodes.length > 0
          ? selectedPoLevelReasonCodes.map(r => r.reasonCode || r)
          : [],
      };

      dispatch(
        fetchInActivePurchaseOrders(requestParams)
      ).then((response) => {
        if (response?.status) {
          const responseData = response.data?.inactivePODetailsList || [];
          setPoData(Array.isArray(responseData) ? responseData : []);
          setTotalPages(response.data?.numberOfPages || 1);
          setLastSynced(new Date());
        } else {
          setPoData([]);
          setTotalPages(1);
        }
        setLoading(false);
        dispatch({
          type: FETCH_PURCHASE_ORDER_LOADING,
          payload: false,
        });
      }).catch((error) => {
        console.error("Error fetching inactive POs:", error);
        setPoData([]);
        setTotalPages(1);
        setLoading(false);
        dispatch({
          type: FETCH_PURCHASE_ORDER_LOADING,
          payload: false,
        });
      });
    }
  };

  const handleStatDateChange = (field, newDate) => {
    // Compute the new pair of values without relying on stale state
    // Normalize: start date → 00:00:00, end date → 23:59:59
    const normalizedFrom = field === 'from' ? (newDate ? moment.utc(newDate).startOf('day') : null) : poStatDateStart;
    let normalizedTo = field === 'to' ? (newDate ? moment.utc(newDate).endOf('day') : null) : poStatDateEnd;

    // If start date is after end date, clear start date
    let normalizedFromMut = normalizedFrom;
    if (field === 'from' && normalizedFromMut && normalizedTo && normalizedFromMut.isAfter(normalizedTo)) {
      normalizedFromMut = null;
    }

    // If end date is before start date, clear end date
    if (normalizedFromMut && normalizedTo && normalizedTo.isBefore(normalizedFromMut)) {
      normalizedTo = null;
    }

    const newFrom = normalizedFromMut;
    const newTo = normalizedTo;

    if (field === 'from') setPoStatDateStart(normalizedFromMut);
    else setPoStatDateEnd(normalizedTo);

    const bothFilled = !!newFrom && !!newTo;
    const bothNull = !newFrom && !newTo;

    if (!bothFilled && !bothNull) return; // one filled, one empty — wait

    setCurrentPage(1);
    setLoading(true);
    dispatch({ type: FETCH_PURCHASE_ORDER_LOADING, payload: true });

    let marketValuesForAPI = null;
    if (searchField === "Market" && selectedMarkets.length > 0) {
      marketValuesForAPI = selectedMarkets.flatMap(market => market.marketorder_be || []);
    }
    let regionCodesForAPI = null;
    if (searchField === "Region" && selectedRegions.length > 0) {
      regionCodesForAPI = selectedRegions.map(region => region.regionCode);
    }

    const isSearchFieldAll =
      searchField === "all" ||
      (searchField === "PO Status" && selectedPOStatuses.length === 0) ||
      (searchField === "Market" && selectedMarkets.length === 0) ||
      (searchField === "Region" && selectedRegions.length === 0) ||
      (searchField === "PO-Level Reason Code" && selectedPoLevelReasonCodes.length === 0);

    const poStatusParams = getPOStatusFilterParams();

    let viewPOOptions = selectedAction === "View all PO" ? "all" : selectedAction
    if(field === 'to' && (selectedAction === "View POs with Stat Date of this month" || selectedAction === "View POs with Stat Date of previous month")){
      viewPOOptions = "all"
      setSelectedAction("View all PO")
    }

    const requestParams = {
      searchField: isSearchFieldAll ? "all" : searchField,
      searchValue: searchField === "PO Status"
        ? poStatusParams.searchValue
        : (isSearchFieldAll || searchField === "Market" || searchField === "Region" || searchField === "PO-Level Reason Code"
          ? null
          : (searchValue ? searchValue.trim() : null)),
      viewPOOption: viewPOOptions,
      poStatDateStart: newFrom ? newFrom.toISOString() : null,
      poStatDateEnd: newTo ? newTo.toISOString() : null,
      plantCodeList: filteredPlantList.length > 0 ? filteredPlantList : [],
      vendorMosymphonyIDList: SelectedCMOList.length > 0 ? SelectedCMOList : (filteredVendorMosymphonyIDList.length > 0 ? filteredVendorMosymphonyIDList : []),
      pageNumber: 1,
      pageSize: rowsPerPage,
      plannerSaasUserIDs: selectedPlannerList.length > 0 ? selectedPlannerList : [],
      brand: selectedBrandList.length > 0 ? selectedBrandList : [],
      productTypeIDs: selectedProductType.length > 0 ? selectedProductType : [],
      aslNumberList: selectedMFGPlantList,
      poStatusIDList: poStatusParams.poStatusIDList,
      marketValues: isSearchFieldAll || searchField !== "Market" || selectedMarkets.length === 0 ? null : marketValuesForAPI,
      regionCodes: isSearchFieldAll || searchField !== "Region" || selectedRegions.length === 0 ? null : regionCodesForAPI,
      poLevelReasonCodes: isSearchFieldAll || searchField !== "PO-Level Reason Code" || selectedPoLevelReasonCodes.length === 0
        ? []
        : selectedPoLevelReasonCodes.map(r => r.reasonCode || r),
    };

    dispatch(fetchInActivePurchaseOrders(requestParams))
      .then((response) => {
        if (response?.status) {
          const responseData = response.data?.inactivePODetailsList || [];
          setPoData(Array.isArray(responseData) ? responseData : []);
          setTotalPages(response.data?.numberOfPages || 1);
          setLastSynced(new Date());
        } else {
          setPoData([]);
          setTotalPages(1);
        }
      })
      .catch((error) => {
        console.error("Error fetching inactive POs on stat date change:", error);
        setPoData([]);
        setTotalPages(1);
      })
      .finally(() => {
        setLoading(false);
        dispatch({ type: FETCH_PURCHASE_ORDER_LOADING, payload: false });
      });
  };

  const handleSaveFilters = async () => {
    setSavingFilters(true);
    dispatch({
      type: OPEN_BACKDROP,
      backdropText: "Please wait...",
    });

    const filtersToSave = {
      ...savedFilter, // Preserve existing saved filter data (same as PO Dashboard)
      cmoListFilter: SelectedCMOList,
      plantListFilter: selectedPlantIdList,
      mfgPlantListFilter: selectedMFGPlantList,
      plannerUserId: selectedPlannerList,
      brand: selectedBrandList,
      productType: selectedProductType,
      // NEW: Persist stat date filter (F1)
      poStatDateStart: poStatDateStart ? poStatDateStart.toISOString() : null,
      poStatDateEnd: poStatDateEnd ? poStatDateEnd.toISOString() : null,
    };

    try {
      const result = await saveDashboardFilters(
        "inactivePODashboard",
        filtersToSave
      );

      if (result.status) {
        dispatch({
          type: DESTROY_BACKDROP,
        });
        setSavedSuccessfull(true);
        setSavingFilters(false);
      } else {
        dispatch({
          type: DESTROY_BACKDROP,
        });
        setSaveFailed(true);
        setSavingFilters(false);
      }
    } catch (error) {
      console.error("Error saving filters:", error);
      dispatch({
        type: DESTROY_BACKDROP,
      });
      setSaveFailed(true);
      setSavingFilters(false);
    }
  };

  const handleCloseSave = () => {
    setSavedSuccessfull(false);
    // Refresh saved filters from server (same as PO Dashboard)
    fetchAllDashboardFilters()
      .then((allFilters) => {
        const inactivePOFilters = extractDashboardFilters(allFilters, 'inactivePODashboard');
        dispatch({
          type: FETCH_PURCHASE_ORDER_FILTER,
          payload: inactivePOFilters
        });
      })
      .catch((err) => {
        console.error("Error fetching inactive PO filters:", err);
        dispatch({
          type: FETCH_PURCHASE_ORDER_FILTER,
          payload: { status: false }
        });
      });
  };

  // Function to make API call with cleared filters - same as PO Dashboard
  const makeClearedFiltersAPICall = () => {
    setLoading(true);
    dispatch({
      type: FETCH_PURCHASE_ORDER_LOADING,
      payload: true,
    });

    dispatch(
      fetchInActivePurchaseOrders({
        searchField: "all",
        searchValue: null,
        viewPOOption: "all",
        poStatDateStart: null,
        poStatDateEnd: null,
        plantCodeList: [],
        vendorMosymphonyIDList: [],
        pageNumber: 1,
        pageSize: rowsPerPage,
        plannerSaasUserIDs: [],
        brand: [],
        productTypeIDs: [],
        aslNumberList: [],
        poStatusIDList: null,
        marketValues: null,
        regionCodes: null,
        poLevelReasonCodes: [],
      })
    ).then((response) => {
      if (response?.status) {
        const responseData = response.data?.inactivePODetailsList || response.data?.poDetailsList || response.data?.purchaseOrders || response.data?.data || [];
        setPoData(Array.isArray(responseData) ? responseData : []);
        setTotalPages(response.data?.numberOfPages || response.data?.totalPages || 1);
        setLastSynced(new Date());
      } else {
        setPoData([]);
        setTotalPages(1);
      }
      setLoading(false);
      dispatch({
        type: FETCH_PURCHASE_ORDER_LOADING,
        payload: false,
      });
    }).catch((error) => {
      console.error("Error fetching inactive POs after clearing filters:", error);
      setPoData([]);
      setTotalPages(1);
      setLoading(false);
      dispatch({
        type: FETCH_PURCHASE_ORDER_LOADING,
        payload: false,
      });
    });
  };

  const handleClearFilters = () => {
    dispatch({
      type: OPEN_BACKDROP,
      backdropText: "Clearing filters...",
    });

    // Clear all filter states - same as PO Dashboard
    setSelectedCMOList([]);
    setSelectedCMOs([]);
    setSelectedPlantIdList([]);
    setFilteredPlantList([]);
    setSelectedMFGPlantList([]);
    setSelectedPlannerList([]);
    setSelectedPlanners([]);
    setSelectedBrandList([]);
    setSelectedBrands([]);
    setFilteredVendorMosymphonyIDList([]);
    setSelectedProductType([]);
    setSearchField("all");
    setSearchValue("");
    setSelectedPOStatuses([]);
    setSelectedMarkets([]);
    setSelectedRegions([]);
    setSelectedPoLevelReasonCodes([]);
    setCurrentPage(1);

    // Reset action list to "View all PO" - same as PO Dashboard
    setSelectedAction("View all PO");

    // NEW: Reset stat date filters (F1)
    setPoStatDateStart(null);
    setPoStatDateEnd(null);

    // Reset to show all options
    setPlantList(allReceivingPlants);
    setPlantIdOptions(allReceivingPlants);
    setMFGPlantList(originalMfgPlantList);
    setPlannerList(plannerOptions);
    setProductTypeOptions(originalProductTypeOptions);

    // Reset previous values
    previousVendorList.current = [];
    previousPlantList.current = [];
    previousPlannerList.current = [];
    previousBrandList.current = [];
    previousProductTypeList.current = [];
    previousMfgPlantList.current = [];


    setSavedFilter({});
    previousApiFilters.current = {};
    hasMadeFirstAPICall.current = false;

    dispatch({
      type: DESTROY_BACKDROP,
    });

    makeClearedFiltersAPICall();
  };

  const handleRefresh = () => {
    // Use savedFilter values for refresh (same as PO Dashboard pattern)
    // This ensures refresh uses the saved filters, not current UI state
    setLoading(true);
    dispatch({
      type: FETCH_PURCHASE_ORDER_LOADING,
      payload: true,
    });

    // Prepare market values for API
    let marketValuesForAPI = null;
    if (searchField === "Market" && selectedMarkets.length > 0) {
      marketValuesForAPI = selectedMarkets.flatMap(market => market.marketorder_be || []);
    }

    // Prepare region codes for API
    let regionCodesForAPI = null;
    if (searchField === "Region" && selectedRegions.length > 0) {
      regionCodesForAPI = selectedRegions.map(region => region.regionCode);
    }

    // Determine if searchField is "all"
    const isSearchFieldAll = searchField === "all" ||
      (searchField === "PO Status" && selectedPOStatuses.length === 0) ||
      (searchField === "Market" && selectedMarkets.length === 0) ||
      (searchField === "Region" && selectedRegions.length === 0) ||
      (searchField === "PO-Level Reason Code" && selectedPoLevelReasonCodes.length === 0);

    // Get PO Status filter params using helper function
    const poStatusParams = getPOStatusFilterParams();


    const plantCodeListForAPI = filteredPlantList.length > 0 ? filteredPlantList : [];
    const vendorMosymphonyIDListForAPI = filteredVendorMosymphonyIDList.length > 0 ? filteredVendorMosymphonyIDList : [];
    const plannerSaasUserIDsForAPI = selectedPlannerList.length > 0 ? selectedPlannerList : [];
    const brandForAPI = selectedBrandList.length > 0 ? selectedBrandList : [];
    const productTypeIDsForAPI = selectedProductType.length > 0 ? selectedProductType : [];

    const requestParams = {
      searchField: isSearchFieldAll ? "all" : searchField,

      searchValue: searchField === "PO Status"
        ? poStatusParams.searchValue
        : (isSearchFieldAll || searchField === "Market" || searchField === "Region" || searchField === "PO-Level Reason Code"
          ? null
          : (searchValue ? searchValue.trim() : null)),
      viewPOOption: selectedAction === "View all PO" ? "all" : selectedAction,
      poStatDateStart: poStatDateStart ? poStatDateStart.toISOString() : null,
      poStatDateEnd: poStatDateEnd ? poStatDateEnd.toISOString() : null,
      plantCodeList: plantCodeListForAPI,
      vendorMosymphonyIDList: vendorMosymphonyIDListForAPI,
      pageNumber: currentPage,
      pageSize: rowsPerPage,
      plannerSaasUserIDs: plannerSaasUserIDsForAPI,
      brand: brandForAPI,
      productTypeIDs: productTypeIDsForAPI,
      aslNumberList: selectedMFGPlantList,
      // Use helper function to properly set poStatusIDList
      poStatusIDList: poStatusParams.poStatusIDList,
      marketValues: isSearchFieldAll || searchField !== "Market" || selectedMarkets.length === 0 ? null : marketValuesForAPI,
      regionCodes: isSearchFieldAll || searchField !== "Region" || selectedRegions.length === 0 ? null : regionCodesForAPI,
      poLevelReasonCodes: isSearchFieldAll || searchField !== "PO-Level Reason Code" || selectedPoLevelReasonCodes.length === 0
        ? []
        : selectedPoLevelReasonCodes.map(r => r.reasonCode || r),
    };

    dispatch(fetchInActivePurchaseOrders(requestParams))
      .then((response) => {
        if (response?.status) {
          const responseData = response.data?.inactivePODetailsList || [];
          setPoData(Array.isArray(responseData) ? responseData : []);
          setTotalPages(response.data?.numberOfPages || 1);
          setLastSynced(new Date());
        } else {
          setPoData([]);
          setTotalPages(1);
        }
        setLoading(false);
        dispatch({
          type: FETCH_PURCHASE_ORDER_LOADING,
          payload: false,
        });
      })
      .catch((error) => {
        console.error("Error refreshing inactive POs:", error);
        setPoData([]);
        setTotalPages(1);
        setLoading(false);
        dispatch({
          type: FETCH_PURCHASE_ORDER_LOADING,
          payload: false,
        });
      });
  };

  // Download handler - calls downloadPurchaseOrdersExcel endpoint and shows Excel preview
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [openExcelPreview, setOpenExcelPreview] = useState(false);
  const [excelData, setExcelData] = useState(null);
  const [excelFileURL, setExcelFileURL] = useState(null);
  const [excelFileName, setExcelFileName] = useState('');
  const [excelPage, setExcelPage] = useState(0);
  const [excelLoading, setExcelLoading] = useState(false);
  const [activeSheetIndex, setActiveSheetIndex] = useState(0);
  const [sheetScrollPositions, setSheetScrollPositions] = useState({});
  const tableContainerRef = useRef(null);

  const handleDownload = async () => {
    try {
      setDownloadLoading(true);
      setExcelLoading(true);
      dispatch({ type: OPEN_BACKDROP });

      // Get PO Status filter params using helper function
      const poStatusParams = getPOStatusFilterParams();

      // Determine if searchField is "all"
      const isSearchFieldAll = searchField === "all" ||
        (searchField === "PO Status" && selectedPOStatuses.length === 0) ||
        (searchField === "Market" && selectedMarkets.length === 0) ||
        (searchField === "Region" && selectedRegions.length === 0) ||
        (searchField === "PO-Level Reason Code" && selectedPoLevelReasonCodes.length === 0);

      const payload = {
        collaboratorTypeID: localStorage.collabType === "CMO" ? 2 : 1,
        vendorMosymphonyIDList: filteredVendorMosymphonyIDList.length > 0 ? filteredVendorMosymphonyIDList : [],
        plantCodeList: filteredPlantList.length > 0 ? filteredPlantList : [],
        brand: selectedBrandList.length > 0 ? selectedBrandList : [],
        plannerSaasUserIDs: selectedPlannerList.length > 0 ? selectedPlannerList : [],
        aslNumberList: selectedMFGPlantList.length > 0 ? selectedMFGPlantList : [],
        deliveryNotCompletePOs: false,
        poStatDateStart: poStatDateStart ? poStatDateStart.toISOString() : null,
        poStatDateEnd: poStatDateEnd ? poStatDateEnd.toISOString() : null,
        productTypeIDs: selectedProductType.length > 0 ? selectedProductType : [],
        searchField: isSearchFieldAll ? "all" : searchField,
        searchValue: searchField === "PO Status"
          ? poStatusParams.searchValue
          : (isSearchFieldAll || searchField === "Market" || searchField === "Region" || searchField === "PO-Level Reason Code"
            ? null
            : (searchValue ? searchValue.trim() : null)),
        viewPOOption: selectedAction === "View all PO" ? "all" : selectedAction,
      };
      const response = await axios.post(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/downloadPurchaseOrdersExcel`,
        payload,
        {
          headers: {
            authtoken: localStorage.getItem("authToken"),
            "X-User-Timezone": Intl.DateTimeFormat().resolvedOptions().timeZone,
          },
          responseType: "blob",
        }
      );

      // Create blob and URL for download
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const url = URL.createObjectURL(blob);
      setExcelFileURL(url);

      // Set filename
      const fileName = `Inactive_POs_${moment().format("YYYY-MM-DD_HH-mm-ss")}.xlsx`;
      setExcelFileName(fileName);

      // Parse Excel data for preview
      try {
        const reader = new FileReader();
        reader.onload = async (e) => {
          const XLSX = await import('xlsx');
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: 'array' });

          // Parse all sheets
          const allSheets = workbook.SheetNames.map((sheetName) => {
            const worksheet = workbook.Sheets[sheetName];
            const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
            return {
              name: sheetName,
              data: jsonData
            };
          });

          setExcelData(allSheets[0]?.data || []);
          setActiveSheetIndex(0);
          setExcelPage(0);
          setOpenExcelPreview(true);
        };
        reader.readAsArrayBuffer(blob);
      } catch (error) {
        console.error('Error parsing Excel:', error);
        // If parsing fails, fall back to direct download
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
      }

      dispatch({ type: DESTROY_BACKDROP });
    } catch (error) {
      dispatch({ type: DESTROY_BACKDROP });
      console.error("Error downloading POs:", error);
    } finally {
      setExcelLoading(false);
      setDownloadLoading(false);
    }
  };

  const handleCloseExcelPreview = () => {
    setOpenExcelPreview(false);
    if (excelFileURL) {
      URL.revokeObjectURL(excelFileURL);
      setExcelFileURL(null);
    }
    setExcelData(null);
    setActiveSheetIndex(0);
    setExcelPage(0);
    setSheetScrollPositions({});
  };

  const groupRowsByPO = (rows) => {
    const grouped = [];
    let currentGroup = null;

    rows.forEach((row, index) => {
      const poNumber = row[0];

      if (poNumber && poNumber !== '') {
        if (currentGroup) {
          grouped.push(currentGroup);
        }
        currentGroup = {
          parentRow: row,
          subRows: [],
          originalIndex: index,
          poNumber: poNumber
        };
      } else if (currentGroup) {
        currentGroup.subRows.push({ row, originalIndex: index });
      }
    });

    if (currentGroup) {
      grouped.push(currentGroup);
    }

    return grouped;
  };



  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'));
  // const isMediumScreen = useMediaQuery(theme.breakpoints.between('md', 'lg'));
  // const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box className={classes.root}>
      {/* Filters Section */}
      <Box className={classes.filterSection}>
        <Box style={{ display: "flex", alignItems: "flex-end", gap: "0.8rem", flexWrap: "wrap" }}>
          {/* Filter 1: CMO - same as PO Dashboard */}
          {localStorage.collabType !== "CMO" && (
            <React.Fragment>
              <Grid
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "10px",
                  flexDirection: "column",
                  marginTop: "10px",
                }}
              >
                <Grid>
                  <Typography style={{ fontWeight: "bold" }} className="dashboard-filter-labels">
                    CMO:
                  </Typography>
                </Grid>

                <Grid>
                  <FormControl
                    variant="outlined"
                    size="small"
                    style={{
                      width: "7rem",
                      marginRight: "0.5rem",
                    }}
                    className="dashboard-filter-dropdown"
                  >
                    <Select
                      multiple
                      fullWidth
                      size="small"
                      variant="outlined"
                      displayEmpty
                      value={
                        SelectedCMOList.length > 0 ? SelectedCMOList : []
                      }
                      onChange={handleChangeCMOList}
                      onClose={() =>
                        handleSelectChangeListLosesFocus("cmo", userAssociationData)
                      }
                      renderValue={(selected) => {
                        const displayValue = selected.length === 0
                          ? "All"
                          : getDisplayCMOFilterValue();

                        return displayValue;
                      }}
                      MenuProps={{
                        PaperProps: {
                          style: {
                            maxHeight: 280,
                            width: "auto",
                            minWidth: "200px",
                          },
                        },
                        getContentAnchorEl: null,
                        anchorOrigin: {
                          vertical: "bottom",
                          horizontal: "left",
                        },
                        transformOrigin: {
                          vertical: "top",
                          horizontal: "left",
                        },
                        variant: "menu",
                        autoFocus: false,
                      }}
                    >
                      <MenuItem value="All">
                        <Checkbox
                          checked={
                            SelectedCMOList.length === availableCMOs.length &&
                            availableCMOs.length > 0
                          }
                        />
                        <ListItemText primary="All" />
                      </MenuItem>
                      {availableCMOs.map((option) => {
                        return (
                          <MenuItem
                            key={option}
                            value={option.organization_id}
                          >
                            <Checkbox
                              checked={
                                SelectedCMOList.indexOf(
                                  option.organization_id
                                ) > -1
                              }
                            />
                            <ListItemText
                              primary={option.organization_name}
                            />
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </React.Fragment>
          )}

          {/* Filter: MFG Plant - same as PO Dashboard */}
          <Grid
            style={{
              display: "flex",
              alignItems: "flex-start",
              gap: "10px",
              flexDirection: "column",
              marginTop: "10px",
            }}
          >
            <Grid>
              <Typography style={{ fontWeight: "bold" }} className="dashboard-filter-labels">
                MFG Plant:
              </Typography>
            </Grid>

            <Grid>
              <FormControl
                variant="outlined"
                size="small"
                style={{
                  width: "7rem",
                  marginRight: "0.5rem",
                }}
                className="dashboard-filter-dropdown"
              >
                <Select
                  multiple
                  fullWidth
                  size="small"
                  variant="outlined"
                  displayEmpty
                  value={
                    selectedMFGPlantList.length > 0
                      ? selectedMFGPlantList
                      : []
                  }
                  onChange={handleChangeMFGPlantList}
                  onClose={() =>
                    handleSelectChangeListLosesFocus("mfgPlants", userAssociationData)
                  }
                  renderValue={(selected) =>
                    selected.length === 0 ? "All" : getDisplayMFGPlantValue()
                  }
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 280,
                        width: "auto",
                        minWidth: "200px",
                      },
                    },
                    getContentAnchorEl: null,
                    anchorOrigin: {
                      vertical: "bottom",
                      horizontal: "left",
                    },
                    transformOrigin: {
                      vertical: "top",
                      horizontal: "left",
                    },
                    variant: "menu",
                    autoFocus: false,
                  }}
                >
                  <MenuItem value="All">
                    <Checkbox
                      checked={
                        selectedMFGPlantList.length === mfgPlantList.length &&
                        mfgPlantList.length > 0
                      }
                    />
                    <ListItemText primary="All" />
                  </MenuItem>
                  {mfgPlantList.map((option) => (
                    <MenuItem key={option.aslNumber} value={option.aslNumber}>
                      <Checkbox
                        checked={selectedMFGPlantList.includes(option.aslNumber)}
                      />
                      <ListItemText primary={option.mfgPlantShortName} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          {/* Filter 2: Plant ID - same as PO Dashboard */}
          <Grid
            style={{
              display: "flex",
              alignItems: "flex-start",
              gap: "10px",
              flexDirection: "column",
              marginTop: "10px",
            }}
          >
            <Grid>
              <Typography style={{ fontWeight: "bold" }} className="dashboard-filter-labels">
                Plant ID:
              </Typography>
            </Grid>

            <Grid>
              <FormControl
                variant="outlined"
                size="small"
                style={{
                  width: "7rem",
                  marginRight: "0.5rem",
                }}
                className="dashboard-filter-dropdown"
              >
                <Select
                  multiple
                  fullWidth
                  size="small"
                  variant="outlined"
                  displayEmpty
                  value={
                    selectedPlantIdList.length > 0
                      ? selectedPlantIdList
                      : []
                  }
                  onChange={handleChangePlantIdList}
                  onClose={() =>
                    handleSelectChangeListLosesFocus("plantID", userAssociationData)
                  }
                  renderValue={(selected) => {
                    const displayValue = selected.length === 0 ? "All" : getDisplayPlantIDValue();

                    return displayValue;
                  }}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 280,
                        width: "auto",
                        minWidth: "200px",
                      },
                    },
                    getContentAnchorEl: null,
                    anchorOrigin: {
                      vertical: "bottom",
                      horizontal: "left",
                    },
                    transformOrigin: {
                      vertical: "top",
                      horizontal: "left",
                    },
                    variant: "menu",
                    autoFocus: false,
                  }}
                >
                  <MenuItem value="All">
                    <Checkbox
                      checked={
                        selectedPlantIdList.length === plantList.length
                      }
                    />
                    <ListItemText primary="All" />
                  </MenuItem>
                  {plantList.map((option) => (
                    <MenuItem key={option} value={option.plantCode}>
                      <Checkbox
                        checked={
                          selectedPlantIdList.indexOf(option.plantCode) > -1
                        }
                      />
                      <ListItemText primary={option.plantCode} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          {/* Filter 3: Planner - same as PO Dashboard */}
          {localStorage.collabType !== "CMO" && (
            <React.Fragment>
              <Grid
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "10px",
                  flexDirection: "column",
                  marginTop: "10px",
                }}
              >
                <Grid>
                  <Typography className="dashboard-filter-labels">
                    Planner:
                  </Typography>
                </Grid>

                <Grid>
                  <FormControl
                    variant="outlined"
                    size="small"
                    style={{
                      width: "7rem",
                      marginRight: "0.5rem",
                    }}
                    className="dashboard-filter-dropdown"
                  >
                    <Select
                      multiple
                      fullWidth
                      size="small"
                      variant="outlined"
                      displayEmpty
                      value={
                        selectedPlannerList.length > 0
                          ? selectedPlannerList
                          : []
                      }
                      onChange={handleChangePlannerList}
                      onClose={() =>
                        handleSelectChangeListLosesFocus("Planner", userAssociationData)
                      }
                      renderValue={(selected) => {
                        const displayValue = selected.length === 0
                          ? "All"
                          : getDisplayPlannerValue();

                        return displayValue;
                      }}
                      MenuProps={{
                        PaperProps: {
                          style: {
                            maxHeight: 280,
                            width: "auto",
                            minWidth: "200px",
                          },
                        },
                        getContentAnchorEl: null,
                        anchorOrigin: {
                          vertical: "bottom",
                          horizontal: "left",
                        },
                        transformOrigin: {
                          vertical: "top",
                          horizontal: "left",
                        },
                        variant: "menu",
                        autoFocus: false,
                      }}
                    >
                      <MenuItem value="All">
                        <Checkbox
                          checked={
                            selectedPlannerList.length ===
                            plannerList.length
                          }
                        />
                        <ListItemText primary="All" />
                      </MenuItem>
                      {plannerList.map((val, ind) => (
                        <MenuItem key={ind} value={val.saasUserID}>
                          <Checkbox checked={selectedPlannerList.includes(val.saasUserID)} />
                          <ListItemText primary={val.name} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </React.Fragment>
          )}

          {/* Filter 4: Brand - same as PO Dashboard */}
          <Grid
            style={{
              display: "flex",
              alignItems: "flex-start",
              gap: "10px",
              flexDirection: "column",
              marginTop: "10px",
            }}
          >
            <Grid>
              <Typography style={{ fontWeight: "bold" }} className="dashboard-filter-labels">Brand:</Typography>
            </Grid>

            <Grid>
              <FormControl
                variant="outlined"
                size="small"
                style={{
                  width: "7rem",
                  marginRight: "0.5rem",
                }}
                className="dashboard-filter-dropdown"
              >
                <Select
                  multiple
                  fullWidth
                  size="small"
                  variant="outlined"
                  displayEmpty
                  value={selectedBrandList || []}
                  onChange={handleChangeBrandList}
                  onClose={() => handleSelectChangeListLosesFocus("brand", userAssociationData)}
                  renderValue={() => {
                    const displayValue = getDisplayBrandValue();

                    return displayValue;
                  }}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 280,
                        width: "auto",
                        minWidth: "200px",
                      },
                    },
                    getContentAnchorEl: null,
                    anchorOrigin: {
                      vertical: "bottom",
                      horizontal: "left",
                    },
                    transformOrigin: {
                      vertical: "top",
                      horizontal: "left",
                    },
                    variant: "menu",
                    autoFocus: false,
                  }}
                >
                  <MenuItem value="All">
                    <Checkbox
                      checked={
                        selectedBrandList.length ===
                        uniqueBrandOptions.length &&
                        uniqueBrandOptions.length > 0
                      }
                    />
                    <ListItemText primary="All" />
                  </MenuItem>
                  {uniqueBrandOptions.map((option) => {
                    const titleCaseBrand = option?.brand && option?.brand
                      .toLowerCase()
                      .split(" ")
                      .map(
                        (word) =>
                          word.charAt(0).toUpperCase() + word.slice(1)
                      )
                      .join(" ");
                    return (
                      <MenuItem key={option?.brand} value={option?.brand}>
                        <Checkbox
                          checked={selectedBrandList.includes(option?.brand)}
                        />
                        <ListItemText primary={titleCaseBrand} />
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          {/* Filter 5: Product Type */}
          <Grid
            style={{
              display: "flex",
              alignItems: "flex-start",
              gap: "10px",
              flexDirection: "column",
              marginTop: "10px",
            }}
          >
            <Grid>
              <Typography style={{ fontWeight: "bold" }} className="dashboard-filter-labels">Product Type:</Typography>
            </Grid>
            <Grid>
              <FormControl
                variant="outlined"
                size="small"
                style={{
                  width: "7rem",
                  marginRight: "0.5rem",
                }}
                className="dashboard-filter-dropdown"
              >
                <Select
                  multiple
                  value={selectedProductType}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value.includes("All")) {
                      setSelectedProductType(
                        selectedProductType.length === productTypeOptions.length
                          ? []
                          : productTypeOptions.map(opt => opt.productTypeID || opt.id || opt.productTypeName || opt)
                      );
                    } else {
                      setSelectedProductType(value);
                    }
                  }}
                  onClose={() => handleSelectChangeListLosesFocus("productType", userAssociationData)}
                  renderValue={(selected) => {
                    if (selected.length === 0) return "All";
                    if (selected.length === 1) {
                      const option = productTypeOptions.find(
                        (opt) => opt.productTypeID === selected[0]
                      );
                      return option ? option.productTypeName : "All";
                    }
                    return "Multiple selection";
                  }}
                  displayEmpty
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 280,
                        width: "auto",
                        minWidth: "200px",
                      },
                    },
                    getContentAnchorEl: null,
                    anchorOrigin: {
                      vertical: "bottom",
                      horizontal: "left",
                    },
                    transformOrigin: {
                      vertical: "top",
                      horizontal: "left",
                    },
                    variant: "menu",
                    autoFocus: false,
                  }}
                >
                  <MenuItem value="All">
                    <Checkbox
                      checked={selectedProductType.length === productTypeOptions.length}
                    />
                    <ListItemText primary="All" />
                  </MenuItem>
                  {productTypeOptions.map((option, index) => {
                    const typeValue = option.productTypeID || option.id || option.productTypeName || option;
                    const typeKey = option.productTypeID || option.id || `type-${index}`;
                    const typeName = option.productTypeName || option.name || option;
                    return (
                      <MenuItem key={typeKey} value={typeValue}>
                        <Checkbox checked={selectedProductType.includes(typeValue)} />
                        <ListItemText primary={typeName} />
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          {/* NEW: Sort by PO Stat Date filter (F1) */}
          <Grid
            style={{
              display: "flex",
              alignItems: "flex-start",
              gap: "10px",
              flexDirection: "column",
              marginTop: "10px",
            }}
          >
            <Grid>
              <Typography style={{ fontWeight: "bold" }} className="dashboard-filter-labels">
                Sort by PO Stat Date:
              </Typography>
            </Grid>
            <Grid style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <MuiPickersUtilsProvider utils={MomentUtils}>
                <DatePicker
                  autoOk
                  variant="inline"
                  inputVariant="outlined"
                  size="small"
                  format="DD-MMM-YYYY"
                  placeholder="Select"
                  maxDate={poStatDateEnd || undefined}
                  value={poStatDateStart}
                  onChange={(date) => handleStatDateChange('from', date)}
                  style={{
                    width: "7rem",
                    marginRight: "0.5rem",
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        {poStatDateStart ? (
                          <IconButton size="small" onClick={(e) => { e.stopPropagation(); handleStatDateChange('from', null); }}>
                            <ClearIcon fontSize="small" />
                          </IconButton>
                        ) : (
                          <EventIcon fontSize="small" style={{ color: "#666" }} />
                        )}
                      </InputAdornment>
                    ),
                  }}
                />
                <Typography variant="body2" style={{ margin: "0 2px" }}>to</Typography>
                <DatePicker
                  autoOk
                  variant="inline"
                  inputVariant="outlined"
                  size="small"
                  format="DD-MMM-YYYY"
                  placeholder="Select"
                  disabled={!poStatDateStart}
                  minDate={poStatDateStart || undefined}
                  value={poStatDateEnd}
                  onChange={(date) => handleStatDateChange('to', date)}
                  style={{
                    width: "7rem",
                    marginRight: "0.5rem",
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        {poStatDateEnd ? (
                          <IconButton size="small" onClick={(e) => { e.stopPropagation(); handleStatDateChange('to', null); }}>
                            <ClearIcon fontSize="small" />
                          </IconButton>
                        ) : (
                          <EventIcon fontSize="small" style={{ color: "#666" }} />
                        )}
                      </InputAdornment>
                    ),
                  }}
                />
              </MuiPickersUtilsProvider>
            </Grid>
          </Grid>

          {/* Save Filters Button */}
          <Box style={{ display: "flex", alignItems: "center", justifyContent: 'space-evenly', flexDirection: 'column', gap: '0.8rem', marginLeft: isLargeScreen ? "10px" : "0px" }}>
            <Button
              variant="contained"
              disableElevation
              disableRipple
              disableFocusRipple
              className={classes.saveButton}
              onClick={handleSaveFilters}
              disabled={savingFilters}
              startIcon={savingFilters ? <CircularProgress size={16} color="inherit" /> : null}
            >
              {savingFilters ? "Saving..." : "Save filters"}
            </Button>
            <Typography
              variant="caption"
              style={{
                fontSize: "14px",
                color: "blue",
                cursor: "pointer",
              }}
              className={classes.clearButton}
              onClick={handleClearFilters}
            >
              Clear all filters
            </Typography>
          </Box>

          {/* Clear Filters Button */}
          {/* <Box style={{ display: "flex", alignItems: "center", marginLeft: "5px" }}>
            <Typography
              variant="caption"
              style={{
                fontSize: "14px",
                color: "blue",
                cursor: "pointer",
              }}
              className={classes.clearButton}
              onClick={handleClearFilters}
            >
              Clear all filters
            </Typography>
          </Box> */}

          {/* Download POs Button (F3: enabled) */}
          <Box style={{ display: "flex", alignItems: "center", justifyContent: 'space-evenly', flexDirection: 'column', marginLeft: isLargeScreen ? "auto" : "0px", gap: "8px" }}>
            {/* NEW: Reset Batch Button (F2) */}
            {featuresAccess?.resetBatch && (
              <Button
                variant="contained"
                disableElevation
                disableRipple
                disableFocusRipple
                className={classes.saveButton}
                onClick={() => setResetBatchDialogOpen(true)}
              >
                Reset Batch
              </Button>
            )}
            <Button
              variant="contained"
              className={classes.downloadButton}
              onClick={handleDownload}
              disabled={downloadLoading}
              startIcon={downloadLoading ? <CircularProgress size={16} color="inherit" /> : null}
            >
              {downloadLoading ? "Downloading..." : "Download POs"}
            </Button>

          </Box>
        </Box>
      </Box>

      {/* Second Section: Search By, List of Actions, Last Synced/Per Page */}
      <Box className={classes.searchSection}>
        {/* Search By Section */}
        <Box className={classes.searchGroup} style={{ flex: 1 }}>
          <Typography className="dashboard-filter-labels">Search By:</Typography>
          <Box
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              gap: "0px",
              flexWrap: "nowrap",
            }}
            className="select-search-by-field"
          >
            <Box style={{ position: "relative", display: "inline-block" }}>
              <Tooltip
                title={searchField !== "all" && searchField.length > 25 ? searchField : ""}
                arrow
                placement="bottom"
                disableHoverListener={searchFieldSelectOpen || searchField === "all" || searchField.length <= 25}
              >
                <TextField
                  size="small"
                  select
                  value={searchField}
                  onChange={handleSearchField}
                  variant="outlined"
                  style={{
                    border: "1px solid black",
                    borderRight: "none",
                    borderRadius: "0.1rem",
                    backgroundColor: "#F0F0F0",
                    minWidth: "200px",
                    maxWidth: "280px",
                    width: "auto",
                    flexShrink: 0,
                  }}
                  className="select-search"
                  SelectProps={{
                    style: {
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    },
                    renderValue: (value) => {
                      if (value === "all") return "Select Criteria";
                      // Truncate long labels
                      const maxLength = 25;
                      if (value.length > maxLength) {
                        return value.substring(0, maxLength) + "...";
                      }
                      return value;
                    },
                    onOpen: () => setSearchFieldSelectOpen(true),
                    onClose: () => setSearchFieldSelectOpen(false),
                    MenuProps: {
                      PaperProps: {
                        style: {
                          maxHeight: 400,
                        },
                      },
                    },
                  }}
                >
                  <MenuItem value="all">Select Criteria</MenuItem>
                  <MenuItem value="PO Number">PO Number</MenuItem>
                  <MenuItem value="Product Code">Product Code</MenuItem>
                  <MenuItem value="Product Description">Product Description</MenuItem>
                  <MenuItem value="BMS Component/Material Code">BMS Component/Material Code</MenuItem>
                  <MenuItem value="BMS Component/Material Description">BMS Component/Material Description</MenuItem>
                  <MenuItem value="Allocated BMS Component/Material Batch Number">Allocated BMS Component/Material Batch Number</MenuItem>
                  <MenuItem value="Date of PO Creation">Date of PO Creation</MenuItem>
                  <MenuItem value="PO Status">PO Status</MenuItem>
                  <MenuItem value="Market">Market</MenuItem>
                  <MenuItem value="Region">Region</MenuItem>
                  <MenuItem value="PO-Level Reason Code">PO-Level Reason Code</MenuItem>
                </TextField>
              </Tooltip>
            </Box>
            {!["PO Status", "Market", "Region", "PO-Level Reason Code"].includes(searchField) && (
              searchField === "Date of PO Creation" ? (
                <MuiPickersUtilsProvider utils={MomentUtils}>
                  <Box ref={datePickerAnchorRef} style={{ flex: 1, minWidth: 0 }}>
                    <TextField
                      size="small"
                      value={selectedDate ? moment(selectedDate).format("DD-MM-YYYY") : ""}
                      placeholder="DD-MM-YYYY"
                      disabled={searchField === "all"}
                      readOnly
                      variant="outlined"
                      style={{
                        flex: 1,
                        minWidth: 0,
                        border: "1px solid black",
                        borderTopRightRadius: "8px",
                        borderBottomRightRadius: "8px",
                        borderTopLeftRadius: "0px",
                        borderBottomLeftRadius: "0px",
                      }}
                      InputProps={{
                        readOnly: true,
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              size="small"
                              onClick={(e) => {
                                e.stopPropagation();
                                setDatePickerOpen(true);
                              }}
                              disabled={searchField === "all"}
                              style={{ padding: "4px" }}
                            >
                              <EventIcon fontSize="small" />
                            </IconButton>
                            {selectedDate && (
                              <Tooltip title="Clear search" aria-label="clear">
                                <Clear
                                  fontSize="small"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setSelectedDate(null);
                                    setSearchValue("");
                                    setDatePickerOpen(false);
                                    setSearchField("all");
                                    setCurrentPage(1);

                                    // Set loading state
                                    setLoading(true);
                                    dispatch({
                                      type: FETCH_PURCHASE_ORDER_LOADING,
                                      payload: true,
                                    });

                                    // Call API directly with cleared values (same as main PO dashboard)
                                    dispatch(
                                      fetchInActivePurchaseOrders({
                                        searchField: "all",
                                        searchValue: null,
                                        viewPOOption:
                                          selectedAction === "View all PO" ? "all" : selectedAction,
                                        plantCodeList:
                                          selectedPlantIdList.length > 0 ? selectedPlantIdList : [],
                                        vendorMosymphonyIDList:
                                          SelectedCMOList.length > 0 ? SelectedCMOList : [],
                                        pageNumber: 1,
                                        pageSize: rowsPerPage,
                                        plannerSaasUserIDs:
                                          selectedPlannerList.length > 0 ? selectedPlannerList : [],
                                        brand: selectedBrandList.length > 0 ? selectedBrandList : [],
                                        productTypeIDs:
                                          selectedProductType.length > 0 ? selectedProductType : [],
                                        poStatusIDList: null,
                                        marketValues: null,
                                        regionCodes: null,
                                        poLevelReasonCodes: [],
                                        aslNumberList: selectedMFGPlantList,
                                        poStatDateStart: poStatDateStart ? poStatDateStart.toISOString() : null,
                                        poStatDateEnd: poStatDateEnd ? poStatDateEnd.toISOString() : null,
                                      })
                                    )
                                      .then((response) => {
                                        if (response?.status) {
                                          const responseData =
                                            response.data?.inactivePODetailsList || [];
                                          setPoData(
                                            Array.isArray(responseData) ? responseData : []
                                          );
                                          setTotalPages(response.data?.numberOfPages || 1);
                                          setLastSynced(new Date());
                                        } else {
                                          setPoData([]);
                                          setTotalPages(1);
                                        }
                                        setLoading(false);
                                        dispatch({
                                          type: FETCH_PURCHASE_ORDER_LOADING,
                                          payload: false,
                                        });
                                      })
                                      .catch((error) => {
                                        console.error("Error fetching inactive POs:", error);
                                        setPoData([]);
                                        setTotalPages(1);
                                        setLoading(false);
                                        dispatch({
                                          type: FETCH_PURCHASE_ORDER_LOADING,
                                          payload: false,
                                        });
                                      });
                                  }}
                                  style={{
                                    cursor: "pointer",
                                    color: "dimgray",
                                  }}
                                />
                              </Tooltip>
                            )}
                            <IconButton
                              size="small"
                              style={{
                                backgroundColor: "#EB5E28",
                                color: "white",
                                borderTopRightRadius: "7px",
                                borderBottomRightRadius: "7px",
                                borderTopLeftRadius: "0px",
                                borderBottomLeftRadius: "0px",
                                padding: "8px",
                                translate: "0.84rem",
                                marginLeft: "0px",
                                marginRight: "0px",
                              }}
                              onClick={() => {
                                setCurrentPage(1);
                                fetchInactivePOs();
                              }}
                            >
                              <SearchIcon />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                    <Popover
                      open={datePickerOpen}
                      anchorEl={datePickerAnchorRef.current}
                      onClose={() => setDatePickerOpen(false)}
                      anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                      }}
                      transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                      }}
                    >
                      <DatePicker
                        autoOk
                        variant="static"
                        value={selectedDate}
                        onChange={(date) => {
                          handleDateChange(date);
                          setDatePickerOpen(false);
                        }}
                        openTo="date"
                      />
                    </Popover>
                  </Box>
                </MuiPickersUtilsProvider>
              ) : (
                <TextField
                  size="small"
                  value={searchValue}
                  disabled={searchField === "all"}
                  onChange={handleSearchValue}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      const { name, value } = e.target;
                      if (searchField !== "all") {
                        handleSearchValue({ target: { name, value: value.trim() } });
                        setCurrentPage(1);
                        fetchInactivePOs();
                      }
                    }
                  }}
                  onBlur={(e) => {
                    const { name, value } = e.target;
                    // Trim leading and trailing spaces for string values
                    if (searchField !== "all" && typeof value === "string" && value.trim() !== value) {
                      handleSearchValue({ target: { name, value: value.trim() } });
                    }
                  }}
                  variant="outlined"
                  placeholder="Search"
                  style={{
                    flex: 1,
                    minWidth: "200px",
                    maxWidth: "100%",
                    border: "1px solid black",
                    borderTopRightRadius: "8px",
                    borderBottomRightRadius: "8px",
                    borderTopLeftRadius: "0px",
                    borderBottomLeftRadius: "0px",
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        {searchValue && (
                          <Tooltip title="Clear search" aria-label="clear">
                            <Clear
                              fontSize="small"
                              onClick={() => {
                                setSelectedPOStatuses([]);
                                setSelectedMarkets([]);
                                setSelectedRegions([]);
                                setSelectedPoLevelReasonCodes([]);

                                // Build cleared filters object (same structure as useEffect will build)
                                const clearedFilters = {
                                  searchField: "all",
                                  searchValue: null, // Use null (not "") to match normalized value
                                  viewPOOption: selectedAction === "View all PO" ? "all" : selectedAction,
                                  poStatDateStart: poStatDateStart ? poStatDateStart.toISOString() : null,
                                  poStatDateEnd: poStatDateEnd ? poStatDateEnd.toISOString() : null,
                                  plantCodeList: Array.isArray(savedFilter?.plantListFilter) ? savedFilter?.plantListFilter : [],
                                  vendorMosymphonyIDList: Array.isArray(savedFilter?.cmoListFilter) ? savedFilter?.cmoListFilter : [],
                                  pageNumber: 1,
                                  pageSize: rowsPerPage,
                                  plannerSaasUserIDs: Array.isArray(savedFilter?.plannerUserId) ? savedFilter?.plannerUserId : [],
                                  brand: Array.isArray(savedFilter?.brand) ? savedFilter?.brand : [],
                                  productTypeIDs: Array.isArray(savedFilter?.productType) ? savedFilter?.productType : [],
                                  poStatusIDList: null,
                                  marketValues: null,
                                  regionCodes: null,
                                  poLevelReasonCodes: [],
                                };


                                previousApiFilters.current = clearedFilters;

                                // Clear search value and field
                                setSearchValue("");
                                setSelectedDate(null);
                                setSearchField("all");
                                setCurrentPage(1);

                                // Set loading state
                                setLoading(true);
                                dispatch({
                                  type: FETCH_PURCHASE_ORDER_LOADING,
                                  payload: true,
                                });

                                // Call API directly with cleared values (same as main PO dashboard)
                                dispatch(
                                  fetchInActivePurchaseOrders({
                                    searchField: "all",
                                    searchValue: null,
                                    viewPOOption: selectedAction === "View all PO" ? "all" : selectedAction,
                                    poStatDateStart: poStatDateStart ? poStatDateStart.toISOString() : null,
                                    poStatDateEnd: poStatDateEnd ? poStatDateEnd.toISOString() : null,
                                    plantCodeList:
                                      selectedPlantIdList.length > 0 ? selectedPlantIdList : [],
                                    vendorMosymphonyIDList:
                                      SelectedCMOList.length > 0 ? SelectedCMOList : [],
                                    pageNumber: 1,
                                    pageSize: rowsPerPage,
                                    plannerSaasUserIDs:
                                      selectedPlannerList.length > 0 ? selectedPlannerList : [],
                                    brand: selectedBrandList.length > 0 ? selectedBrandList : [],
                                    productTypeIDs:
                                      selectedProductType.length > 0 ? selectedProductType : [],
                                    poStatusIDList: null,
                                    marketValues: null,
                                    regionCodes: null,
                                    poLevelReasonCodes: [],
                                    aslNumberList: selectedMFGPlantList,
                                  })
                                )
                                  .then((response) => {
                                    if (response?.status) {
                                      const responseData =
                                        response.data?.inactivePODetailsList || [];
                                      setPoData(
                                        Array.isArray(responseData) ? responseData : []
                                      );
                                      setTotalPages(response.data?.numberOfPages || 1);
                                      setLastSynced(new Date());
                                    } else {
                                      setPoData([]);
                                      setTotalPages(1);
                                    }
                                    setLoading(false);
                                    dispatch({
                                      type: FETCH_PURCHASE_ORDER_LOADING,
                                      payload: false,
                                    });
                                  })
                                  .catch((error) => {
                                    console.error("Error fetching inactive POs:", error);
                                    setPoData([]);
                                    setTotalPages(1);
                                    setLoading(false);
                                    dispatch({
                                      type: FETCH_PURCHASE_ORDER_LOADING,
                                      payload: false,
                                    });
                                  });
                              }}
                              style={{
                                cursor: "pointer",
                                color: "dimgray",
                              }}
                            />
                          </Tooltip>
                        )}
                        <IconButton
                          size="small"
                          style={{
                            backgroundColor: "#EB5E28",
                            color: "white",
                            borderTopRightRadius: "7px",
                            borderBottomRightRadius: "7px",
                            borderTopLeftRadius: "0px",
                            borderBottomLeftRadius: "0px",
                            padding: "8px",
                            translate: "0.84rem",
                            marginLeft: "0px",
                            marginRight: "0px",
                          }}
                          onClick={() => {
                            setCurrentPage(1);
                            fetchInactivePOs();
                          }}
                        >
                          <SearchIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              )
            )}

            {/* PO Status Dropdown - same as PO Dashboard */}
            {searchField === "PO Status" && (
              <Box style={{ position: "relative", flex: 1, minWidth: 0, width: "100%" }}>
                <FormControl
                  fullWidth
                  style={{
                    width: "100%",
                    height: "40px",
                    minHeight: "40px",
                    maxHeight: "40px",
                    border: "1px solid black",
                    borderTopRightRadius: "8px",
                    borderBottomRightRadius: "8px",
                    borderTopLeftRadius: "0px",
                    borderBottomLeftRadius: "0px",
                    overflow: "hidden",
                  }}
                >
                  <Select
                    multiple
                    fullWidth
                    variant="outlined"
                    disableUnderline
                    value={selectedPOStatuses}
                    onChange={(e) => {
                      let value = e.target.value;
                      if (!Array.isArray(value)) {
                        value = value ? [value] : [];
                      }

                      setSelectedPOStatuses(value);
                      if (value.length > 0) {
                        const statusIds = value.map(status => status.status_id);
                        setSearchValue(statusIds);
                      } else {
                        setSearchValue([]);
                      }
                    }}
                    displayEmpty
                    renderValue={(selected) => {
                      if (selected.length === 0) {
                        return <span style={{ color: "#999" }}>Select</span>;
                      } else if (selected.length === 1) {
                        return selected[0].status_name;
                      } else {
                        return "Multiple selection";
                      }
                    }}
                    style={{
                      height: "40px",
                      minHeight: "40px",
                      maxHeight: "40px",
                      padding: "8px 50px 8px 14px",
                      width: "100%",
                      overflow: "hidden",
                    }}
                    IconComponent={() => (
                      <ArrowDropDownIcon
                        style={{
                          position: "absolute",
                          right: "75px",
                          top: "6px",
                          pointerEvents: "none",
                          color: "rgba(0, 0, 0)"
                        }}
                      />
                    )}
                    MenuProps={{
                      PaperProps: {
                        style: {
                          maxHeight: 300,
                          overflowY: 'auto',
                        },
                      },
                    }}
                  >
                    {poStatusArray.length > 0 ? (
                      poStatusArray.map((status) => (
                        <MenuItem key={status.status_id} value={status}>
                          <Checkbox
                            checked={selectedPOStatuses.some(selected => selected.status_id === status.status_id)}
                          />
                          <ListItemText primary={status.status_name} />
                        </MenuItem>
                      ))
                    ) : (
                      <MenuItem disabled>No PO Statuses available</MenuItem>
                    )}
                  </Select>
                </FormControl>
                <Box style={{ position: "absolute", right: "40px", top: "50%", transform: "translateY(-50%)", pointerEvents: "none" }}>
                  {selectedPOStatuses.length > 0 && (
                    <Tooltip title="Clear search">
                      <Box style={{ pointerEvents: "auto" }}>
                        <Clear
                          fontSize="small"
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            // Clear PO Status values
                            setSelectedPOStatuses([]);
                            setSearchValue([]);
                            setSearchField("all");
                            setCurrentPage(1);

                            // Set loading state
                            setLoading(true);
                            dispatch({
                              type: FETCH_PURCHASE_ORDER_LOADING,
                              payload: true,
                            });
                            dispatch(
                              fetchInActivePurchaseOrders({
                                searchField: "all",
                                searchValue: null,
                                viewPOOption: selectedAction === "View all PO" ? "all" : selectedAction,
                                poStatDateStart: poStatDateStart ? poStatDateStart.toISOString() : null,
                                poStatDateEnd: poStatDateEnd ? poStatDateEnd.toISOString() : null,
                                plantCodeList: selectedPlantIdList.length > 0 ? selectedPlantIdList : [],
                                vendorMosymphonyIDList: SelectedCMOList.length > 0 ? SelectedCMOList : [],
                                pageNumber: 1,
                                pageSize: rowsPerPage,
                                plannerSaasUserIDs: selectedPlannerList.length > 0 ? selectedPlannerList : [],
                                brand: selectedBrandList.length > 0 ? selectedBrandList : [],
                                productTypeIDs: selectedProductType.length > 0 ? selectedProductType : [],
                                poStatusIDList: null,
                                marketValues: null,
                                regionCodes: null,
                                poLevelReasonCodes: [],
                                aslNumberList: selectedMFGPlantList,
                              })
                            ).then((response) => {
                              if (response?.status) {
                                const responseData = response.data?.inactivePODetailsList || [];
                                setPoData(Array.isArray(responseData) ? responseData : []);
                                setTotalPages(response.data?.numberOfPages || 1);
                                setLastSynced(new Date());
                              } else {
                                setPoData([]);
                                setTotalPages(1);
                              }
                              setLoading(false);
                              dispatch({
                                type: FETCH_PURCHASE_ORDER_LOADING,
                                payload: false,
                              });
                            }).catch((error) => {
                              console.error("Error fetching inactive POs:", error);
                              setPoData([]);
                              setTotalPages(1);
                              setLoading(false);
                              dispatch({
                                type: FETCH_PURCHASE_ORDER_LOADING,
                                payload: false,
                              });
                            });
                          }}
                          style={{
                            cursor: "pointer",
                            color: "dimgray",
                            marginRight: "4px",
                          }}
                        />
                      </Box>
                    </Tooltip>
                  )}
                </Box>
                <Box style={{ position: "absolute", right: "0px", top: "50%", transform: "translateY(-50%)", pointerEvents: "auto" }}>
                  <IconButton
                    size="small"
                    style={{
                      backgroundColor: "#EB5E28",
                      color: "white",
                      borderRadius: "4px",
                      minWidth: "32px",
                      height: "40px",
                      padding: "8px",
                      borderTopRightRadius: "7px",
                      borderBottomRightRadius: "7px",
                      borderTopLeftRadius: "0px",
                      borderBottomLeftRadius: "0px",
                      margin: "0px",
                    }}
                    disabled={selectedPOStatuses.length === 0}
                    onClick={() => {
                      setCurrentPage(1);
                      fetchInactivePOs();
                    }}
                  >
                    <SearchIcon />
                  </IconButton>
                </Box>
              </Box>
            )}

            {/* Market Dropdown - same as PO Dashboard */}
            {searchField === "Market" && (
              <Box style={{ position: "relative", flex: 1, minWidth: 0, width: "100%" }}>
                <FormControl
                  fullWidth
                  style={{
                    width: "100%",
                    height: "40px",
                    minHeight: "40px",
                    maxHeight: "40px",
                    border: "1px solid black",
                    borderTopRightRadius: "8px",
                    borderBottomRightRadius: "8px",
                    borderTopLeftRadius: "0px",
                    borderBottomLeftRadius: "0px",
                    overflow: "hidden",
                  }}
                >
                  <Select
                    multiple
                    fullWidth
                    variant="outlined"
                    disableUnderline
                    value={selectedMarkets.map(m => m.market_group)}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value.includes("All")) {
                        setSelectedMarkets(
                          selectedMarkets.length === displayMarketValues.length ? [] : displayMarketValues
                        );
                        setSearchValue(
                          selectedMarkets.length === displayMarketValues.length ? [] : displayMarketValues.map(m => m.market_group)
                        );
                      } else {
                        const selectedMarketObjects = value.map(marketGroup =>
                          displayMarketValues.find(m => m.market_group === marketGroup)
                        ).filter(Boolean);
                        setSelectedMarkets(selectedMarketObjects);
                        setSearchValue(value);
                      }
                    }}
                    displayEmpty
                    renderValue={(selected) => {
                      if (selected.length === 0) {
                        return <span style={{ color: "#999" }}>Select</span>;
                      }
                      if (selected.length === displayMarketValues.length) {
                        return "All";
                      }
                      if (selected.length === 1) {
                        return selected[0] || "";
                      }
                      return "Multiple selection";
                    }}
                    style={{
                      height: "40px",
                      minHeight: "40px",
                      maxHeight: "40px",
                      width: "100%",
                      overflow: "hidden",
                    }}
                    IconComponent={() => (
                      <ArrowDropDownIcon
                        style={{
                          position: "absolute",
                          right: "75px",
                          top: "6px",
                          pointerEvents: "none",
                          color: "rgba(0, 0, 0)"
                        }}
                      />
                    )}
                    MenuProps={{
                      PaperProps: {
                        style: {
                          maxHeight: 300,
                          overflowY: 'auto',
                        },
                      },
                    }}
                  >
                    <MenuItem value="All">
                      <Checkbox
                        checked={selectedMarkets.length === displayMarketValues.length && displayMarketValues.length > 0}
                      />
                      <ListItemText primary="All" />
                    </MenuItem>
                    {displayMarketValues.map((option) => (
                      <MenuItem key={option.market_group} value={option.market_group}>
                        <Checkbox
                          checked={selectedMarkets.some(m => m.market_group === option.market_group)}
                        />
                        <ListItemText primary={option.market_group} />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <Box style={{ position: "absolute", right: "40px", top: "50%", transform: "translateY(-50%)", pointerEvents: "none" }}>
                  {selectedMarkets.length > 0 && (
                    <Tooltip title="Clear search">
                      <Box style={{ pointerEvents: "auto" }}>
                        <Clear
                          fontSize="small"
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            // Clear Market values
                            setSelectedMarkets([]);
                            setSearchValue([]);
                            setSearchField("all");
                            setCurrentPage(1);

                            // Set loading state
                            setLoading(true);
                            dispatch({
                              type: FETCH_PURCHASE_ORDER_LOADING,
                              payload: true,
                            });
                            dispatch(
                              fetchInActivePurchaseOrders({
                                searchField: "all",
                                searchValue: null,
                                viewPOOption: selectedAction === "View all PO" ? "all" : selectedAction,
                                poStatDateStart: poStatDateStart ? poStatDateStart.toISOString() : null,
                                poStatDateEnd: poStatDateEnd ? poStatDateEnd.toISOString() : null,
                                plantCodeList: filteredPlantList.length > 0 ? filteredPlantList : [],
                                vendorMosymphonyIDList: filteredVendorMosymphonyIDList.length > 0 ? filteredVendorMosymphonyIDList : [],
                                pageNumber: 1,
                                pageSize: rowsPerPage,
                                plannerSaasUserIDs: selectedPlannerList.length > 0 ? selectedPlannerList : [],
                                brand: selectedBrandList.length > 0 ? selectedBrandList : [],
                                productTypeIDs: selectedProductType.length > 0 ? selectedProductType : [],
                                poStatusIDList: null,
                                marketValues: null,
                                regionCodes: null,
                                poLevelReasonCodes: [],
                                aslNumberList: selectedMFGPlantList,
                              })
                            ).then((response) => {
                              if (response?.status) {
                                const responseData = response.data?.inactivePODetailsList || [];
                                setPoData(Array.isArray(responseData) ? responseData : []);
                                setTotalPages(response.data?.numberOfPages || 1);
                                setLastSynced(new Date());
                              } else {
                                setPoData([]);
                                setTotalPages(1);
                              }
                              setLoading(false);
                              dispatch({
                                type: FETCH_PURCHASE_ORDER_LOADING,
                                payload: false,
                              });
                            }).catch((error) => {
                              console.error("Error fetching inactive POs:", error);
                              setPoData([]);
                              setTotalPages(1);
                              setLoading(false);
                              dispatch({
                                type: FETCH_PURCHASE_ORDER_LOADING,
                                payload: false,
                              });
                            });
                          }}
                          style={{
                            cursor: "pointer",
                            color: "dimgray",
                            marginRight: "4px",
                          }}
                        />
                      </Box>
                    </Tooltip>
                  )}
                </Box>
                <Box style={{ position: "absolute", right: "0px", top: "50%", transform: "translateY(-50%)", pointerEvents: "auto" }}>
                  <IconButton
                    size="small"
                    style={{
                      backgroundColor: "#EB5E28",
                      color: "white",
                      borderRadius: "4px",
                      minWidth: "32px",
                      height: "40px",
                      padding: "8px",
                      borderTopRightRadius: "7px",
                      borderBottomRightRadius: "7px",
                      borderTopLeftRadius: "0px",
                      borderBottomLeftRadius: "0px",
                      margin: "0px",
                    }}
                    disabled={selectedMarkets.length === 0}
                    onClick={() => {
                      setCurrentPage(1);
                      fetchInactivePOs();
                    }}
                  >
                    <SearchIcon />
                  </IconButton>
                </Box>
              </Box>
            )}

            {/* Region Dropdown - same as PO Dashboard */}
            {searchField === "Region" && (
              <Box style={{ position: "relative", flex: 1, minWidth: 0, width: "100%" }}>
                <FormControl
                  fullWidth
                  style={{
                    width: "100%",
                    height: "40px",
                    minHeight: "40px",
                    maxHeight: "40px",
                    border: "1px solid black",
                    borderTopRightRadius: "8px",
                    borderBottomRightRadius: "8px",
                    borderTopLeftRadius: "0px",
                    borderBottomLeftRadius: "0px",
                    overflow: "hidden",
                  }}
                >
                  <Select
                    multiple
                    fullWidth
                    variant="outlined"
                    disableUnderline
                    value={selectedRegions.map(r => r.regionCode)}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value.includes("All")) {
                        setSelectedRegions(
                          selectedRegions.length === displayRegionValues.length ? [] : displayRegionValues
                        );
                        setSearchValue(
                          selectedRegions.length === displayRegionValues.length ? [] : displayRegionValues.map(r => r.regionCode)
                        );
                      } else {
                        const selectedRegionObjects = value.map(regionCode =>
                          displayRegionValues.find(r => r.regionCode === regionCode)
                        ).filter(Boolean);
                        setSelectedRegions(selectedRegionObjects);
                        setSearchValue(value);
                      }
                    }}
                    displayEmpty
                    renderValue={(selected) => {
                      if (selected.length === 0) {
                        return <span style={{ color: "#999" }}>Select</span>;
                      }
                      if (selected.length === displayRegionValues.length) {
                        return "All";
                      }
                      if (selected.length === 1) {
                        return selected[0] || "";
                      }
                      return "Multiple selection";
                    }}
                    style={{
                      height: "40px",
                      minHeight: "40px",
                      maxHeight: "40px",
                      width: "100%",
                      overflow: "hidden",
                    }}
                    IconComponent={() => (
                      <ArrowDropDownIcon
                        style={{
                          position: "absolute",
                          right: "75px",
                          top: "6px",
                          pointerEvents: "none",
                          color: "rgba(0, 0, 0)"
                        }}
                      />
                    )}
                    MenuProps={{
                      PaperProps: {
                        style: {
                          maxHeight: 300,
                          overflowY: 'auto',
                        },
                      },
                    }}
                  >
                    <MenuItem value="All">
                      <Checkbox
                        checked={selectedRegions.length === displayRegionValues.length && displayRegionValues.length > 0}
                      />
                      <ListItemText primary="All" />
                    </MenuItem>
                    {displayRegionValues.map((option) => (
                      <MenuItem key={option.regionCode} value={option.regionCode}>
                        <Checkbox
                          checked={selectedRegions.some(r => r.regionCode === option.regionCode)}
                        />
                        <ListItemText primary={option.regionCode} />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <Box style={{ position: "absolute", right: "40px", top: "50%", transform: "translateY(-50%)", pointerEvents: "none" }}>
                  {selectedRegions.length > 0 && (
                    <Tooltip title="Clear search">
                      <Box style={{ pointerEvents: "auto" }}>
                        <Clear
                          fontSize="small"
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            // Clear Region values
                            setSelectedRegions([]);
                            setSearchValue([]);
                            setSearchField("all");
                            setCurrentPage(1);

                            // Set loading state
                            setLoading(true);
                            dispatch({
                              type: FETCH_PURCHASE_ORDER_LOADING,
                              payload: true,
                            });
                            dispatch(
                              fetchInActivePurchaseOrders({
                                searchField: "all",
                                searchValue: null,
                                viewPOOption: selectedAction === "View all PO" ? "all" : selectedAction,
                                poStatDateStart: poStatDateStart ? poStatDateStart.toISOString() : null,
                                poStatDateEnd: poStatDateEnd ? poStatDateEnd.toISOString() : null,
                                plantCodeList: filteredPlantList.length > 0 ? filteredPlantList : [],
                                vendorMosymphonyIDList: filteredVendorMosymphonyIDList.length > 0 ? filteredVendorMosymphonyIDList : [],
                                pageNumber: 1,
                                pageSize: rowsPerPage,
                                plannerSaasUserIDs: selectedPlannerList.length > 0 ? selectedPlannerList : [],
                                brand: selectedBrandList.length > 0 ? selectedBrandList : [],
                                productTypeIDs: selectedProductType.length > 0 ? selectedProductType : [],
                                poStatusIDList: null,
                                marketValues: null,
                                regionCodes: null,
                                poLevelReasonCodes: [],
                                aslNumberList: selectedMFGPlantList,
                              })
                            ).then((response) => {
                              if (response?.status) {
                                const responseData = response.data?.inactivePODetailsList || [];
                                setPoData(Array.isArray(responseData) ? responseData : []);
                                setTotalPages(response.data?.numberOfPages || 1);
                                setLastSynced(new Date());
                              } else {
                                setPoData([]);
                                setTotalPages(1);
                              }
                              setLoading(false);
                              dispatch({
                                type: FETCH_PURCHASE_ORDER_LOADING,
                                payload: false,
                              });
                            }).catch((error) => {
                              console.error("Error fetching inactive POs:", error);
                              setPoData([]);
                              setTotalPages(1);
                              setLoading(false);
                              dispatch({
                                type: FETCH_PURCHASE_ORDER_LOADING,
                                payload: false,
                              });
                            });
                          }}
                          style={{
                            cursor: "pointer",
                            color: "dimgray",
                            marginRight: "4px",
                          }}
                        />
                      </Box>
                    </Tooltip>
                  )}
                </Box>
                <Box style={{ position: "absolute", right: "0px", top: "50%", transform: "translateY(-50%)", pointerEvents: "auto" }}>
                  <IconButton
                    size="small"
                    style={{
                      backgroundColor: "#EB5E28",
                      color: "white",
                      borderRadius: "4px",
                      minWidth: "32px",
                      height: "40px",
                      padding: "8px",
                      borderTopRightRadius: "7px",
                      borderBottomRightRadius: "7px",
                      borderTopLeftRadius: "0px",
                      borderBottomLeftRadius: "0px",
                      margin: "0px",
                    }}
                    disabled={selectedRegions.length === 0}
                    onClick={() => {
                      setCurrentPage(1);
                      fetchInactivePOs();
                    }}
                  >
                    <SearchIcon />
                  </IconButton>
                </Box>
              </Box>
            )}

            {/* PO-Level Reason Code Dropdown - same pattern as PO Status, Market, Region */}
            {searchField === "PO-Level Reason Code" && (
              <Box style={{ position: "relative", flex: 1, minWidth: 0, width: "100%" }}>
                <FormControl
                  fullWidth
                  style={{
                    width: "100%",
                    height: "40px",
                    minHeight: "40px",
                    maxHeight: "40px",
                    border: "1px solid black",
                    borderTopRightRadius: "8px",
                    borderBottomRightRadius: "8px",
                    borderTopLeftRadius: "0px",
                    borderBottomLeftRadius: "0px",
                    overflow: "hidden",
                  }}
                >
                  <Select
                    multiple
                    fullWidth
                    variant="outlined"
                    disableUnderline
                    value={selectedPoLevelReasonCodes.map(r => r.reasonCode)}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value.includes("All")) {
                        // Toggle select all / unselect all
                        setSelectedPoLevelReasonCodes(
                          selectedPoLevelReasonCodes.length === poLevelReasonCodeOptions.length ? [] : poLevelReasonCodeOptions
                        );
                        setSearchValue(
                          selectedPoLevelReasonCodes.length === poLevelReasonCodeOptions.length ? [] : poLevelReasonCodeOptions.map(r => r.reasonCode)
                        );
                      } else {
                        // Convert reasonCode strings to full reason code objects
                        const selectedReasonCodeObjects = value.map(reasonCode =>
                          poLevelReasonCodeOptions.find(r => r.reasonCode === reasonCode)
                        ).filter(Boolean);
                        setSelectedPoLevelReasonCodes(selectedReasonCodeObjects);
                        setSearchValue(value);
                      }
                    }}
                    displayEmpty
                    renderValue={(selected) => {
                      if (selected.length === 0) {
                        return <span style={{ color: "#999" }}>Select</span>;
                      }
                      if (selected.length === poLevelReasonCodeOptions.length) {
                        return "All";
                      }
                      if (selected.length === 1) {
                        return selected[0] || "";
                      }
                      return "Multiple selection";
                    }}
                    style={{
                      height: "40px",
                      minHeight: "40px",
                      maxHeight: "40px",
                      width: "100%",
                      overflow: "hidden",
                    }}
                    IconComponent={() => (
                      <ArrowDropDownIcon
                        style={{
                          position: "absolute",
                          right: "75px",
                          top: "6px",
                          pointerEvents: "none",
                          color: "rgba(0, 0, 0)"
                        }}
                      />
                    )}
                    MenuProps={{
                      PaperProps: {
                        style: {
                          maxHeight: 300,
                          overflowY: 'auto',
                        },
                      },
                    }}
                  >
                    <MenuItem value="All">
                      <Checkbox
                        checked={selectedPoLevelReasonCodes.length === poLevelReasonCodeOptions.length && poLevelReasonCodeOptions.length > 0}
                      />
                      <ListItemText primary="All" />
                    </MenuItem>
                    {poLevelReasonCodeOptions.map((option) => (
                      <MenuItem key={option.reasonCodeID || option.reasonCode} value={option.reasonCode}>
                        <Checkbox
                          checked={selectedPoLevelReasonCodes.some(r => r.reasonCode === option.reasonCode)}
                        />
                        <ListItemText primary={`${option.reasonCode} / ${option.reasonDescription || ""}`} />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <Box style={{ position: "absolute", right: "40px", top: "50%", transform: "translateY(-50%)", pointerEvents: "none" }}>
                  {selectedPoLevelReasonCodes.length > 0 && (
                    <Tooltip title="Clear search">
                      <Box style={{ pointerEvents: "auto" }}>
                        <Clear
                          fontSize="small"
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            // Clear PO-Level Reason Code values
                            setSelectedPoLevelReasonCodes([]);
                            setSearchValue([]);
                            setSearchField("all");
                            setCurrentPage(1);

                            // Set loading state
                            setLoading(true);
                            dispatch({
                              type: FETCH_PURCHASE_ORDER_LOADING,
                              payload: true,
                            });
                            dispatch(
                              fetchInActivePurchaseOrders({
                                searchField: "all",
                                searchValue: null,
                                viewPOOption: selectedAction === "View all PO" ? "all" : selectedAction,
                                poStatDateStart: poStatDateStart ? poStatDateStart.toISOString() : null,
                                poStatDateEnd: poStatDateEnd ? poStatDateEnd.toISOString() : null,
                                plantCodeList: filteredPlantList.length > 0 ? filteredPlantList : [],
                                vendorMosymphonyIDList: filteredVendorMosymphonyIDList.length > 0 ? filteredVendorMosymphonyIDList : [],
                                pageNumber: 1,
                                pageSize: rowsPerPage,
                                plannerSaasUserIDs: selectedPlannerList.length > 0 ? selectedPlannerList : [],
                                brand: selectedBrandList.length > 0 ? selectedBrandList : [],
                                productTypeIDs: selectedProductType.length > 0 ? selectedProductType : [],
                                poStatusIDList: null,
                                marketValues: null,
                                regionCodes: null,
                                poLevelReasonCodes: [],
                                aslNumberList: selectedMFGPlantList,
                              })
                            ).then((response) => {
                              if (response?.status) {
                                const responseData = response.data?.inactivePODetailsList || [];
                                setPoData(Array.isArray(responseData) ? responseData : []);
                                setTotalPages(response.data?.numberOfPages || 1);
                                setLastSynced(new Date());
                              } else {
                                setPoData([]);
                                setTotalPages(1);
                              }
                              setLoading(false);
                              dispatch({
                                type: FETCH_PURCHASE_ORDER_LOADING,
                                payload: false,
                              });
                            }).catch((error) => {
                              console.error("Error fetching inactive POs:", error);
                              setPoData([]);
                              setTotalPages(1);
                              setLoading(false);
                              dispatch({
                                type: FETCH_PURCHASE_ORDER_LOADING,
                                payload: false,
                              });
                            });
                          }}
                          style={{
                            cursor: "pointer",
                            color: "dimgray",
                            marginRight: "4px",
                          }}
                        />
                      </Box>
                    </Tooltip>
                  )}
                </Box>
                <Box style={{ position: "absolute", right: "0px", top: "50%", transform: "translateY(-50%)", pointerEvents: "auto" }}>
                  <IconButton
                    size="small"
                    style={{
                      backgroundColor: "#EB5E28",
                      color: "white",
                      borderRadius: "4px",
                      minWidth: "32px",
                      height: "40px",
                      padding: "8px",
                      borderTopRightRadius: "7px",
                      borderBottomRightRadius: "7px",
                      borderTopLeftRadius: "0px",
                      borderBottomLeftRadius: "0px",
                      margin: "0px",
                    }}
                    disabled={selectedPoLevelReasonCodes.length === 0}
                    onClick={() => {
                      setCurrentPage(1);
                      fetchInactivePOs();
                    }}
                  >
                    <SearchIcon />
                  </IconButton>
                </Box>
              </Box>
            )}
          </Box>
        </Box>

        {/* List of Actions Section */}
        <Box className={classes.actionGroup} style={{ flex: 1 }}>
          <Typography className="dashboard-filter-labels">List of Actions:</Typography>
          <FormControl variant="outlined" size="small" className="dashboard-select-dropdown" style={{ width: "100%" }}>
            <Select
              value={selectedAction}
              displayEmpty
              fullWidth
              onChange={async (e) => {
                const newAction = e.target.value;
                setSelectedAction(newAction);
                setCurrentPage(1);

                setLoading(true);
                dispatch({
                  type: FETCH_PURCHASE_ORDER_LOADING,
                  payload: true,
                });

                try {
                  // Prepare market values for API - same as PO Dashboard
                  let marketValuesForAPI = null;
                  if (searchField === "Market" && selectedMarkets.length > 0) {
                    marketValuesForAPI = selectedMarkets.flatMap(market => market.marketorder_be || []);
                  }

                  // Prepare region codes for API - same as PO Dashboard
                  let regionCodesForAPI = null;
                  if (searchField === "Region" && selectedRegions.length > 0) {
                    regionCodesForAPI = selectedRegions.map(region => region.regionCode);
                  }

                  // Get PO Status filter params using helper function
                  const poStatusParams = getPOStatusFilterParams();

                  let statDateEnd = null;
                  let statDateStart = null;
                  if (newAction === "View POs with Stat Date of this month" || newAction === "View POs with Stat Date of previous month") {  
                    setPoStatDateStart(null)
                    setPoStatDateEnd(null)
                  } else{
                    statDateStart = poStatDateStart ? poStatDateStart.toISOString() : null;
                    statDateEnd = poStatDateEnd ? poStatDateEnd.toISOString() : null;
                  }

                  const requestParams = {
                    searchField: searchField === "PO Status" && selectedPOStatuses.length === 0
                      ? "all"
                      : (searchField === "Market" && selectedMarkets.length === 0)
                        ? "all"
                        : (searchField === "Region" && selectedRegions.length === 0)
                          ? "all"
                          : ((searchField === "PO-level Reason Code / Description" || searchField === "PO-Level Reason Code") && selectedPoLevelReasonCodes.length === 0)
                            ? "all"
                            : searchField,

                    searchValue: searchField === "PO Status"
                      ? poStatusParams.searchValue
                      : (searchField !== "all" &&
                        searchField !== "Market" &&
                        searchField !== "Region" &&
                        searchField !== "PO-level Reason Code / Description" &&
                        searchField !== "PO-Level Reason Code" &&
                        searchValue
                        ? searchValue.trim()
                        : null),
                    viewPOOption: newAction === "View all PO" ? "all" : newAction,
                    poStatDateStart: statDateStart,
                    poStatDateEnd: statDateEnd,
                    plantCodeList: filteredPlantList.length > 0 ? filteredPlantList : [],
                    vendorMosymphonyIDList: filteredVendorMosymphonyIDList.length > 0 ? filteredVendorMosymphonyIDList : [],
                    pageNumber: 1,
                    pageSize: rowsPerPage,
                    plannerSaasUserIDs: selectedPlannerList.length > 0 ? selectedPlannerList : [],
                    brand: selectedBrandList.length > 0 ? selectedBrandList : [],
                    productTypeIDs: selectedProductType.length > 0 ? selectedProductType : [],
                    // Use helper function to properly set poStatusIDList
                    poStatusIDList: poStatusParams.poStatusIDList,
                    marketValues: marketValuesForAPI,
                    regionCodes: regionCodesForAPI,
                    poLevelReasonCodes: (searchField === "PO-level Reason Code / Description" || searchField === "PO-Level Reason Code") && selectedPoLevelReasonCodes.length > 0
                      ? selectedPoLevelReasonCodes.map(r => r.reasonCode || r)
                      : [],
                    aslNumberList: selectedMFGPlantList,
                  };

                  const response = await dispatch(
                    fetchInActivePurchaseOrders(requestParams)
                  );

                  if (response?.status) {
                    const responseData = response.data?.inactivePODetailsList || response.data?.poDetailsList || response.data?.purchaseOrders || response.data?.data || [];
                    setPoData(Array.isArray(responseData) ? responseData : []);
                    setTotalPages(response.data?.numberOfPages || response.data?.totalPages || 1);
                    setLastSynced(new Date());
                  } else {
                    setPoData([]);
                    setTotalPages(1);
                  }
                } catch (error) {
                  console.error("Error fetching inactive POs:", error);
                  setPoData([]);
                  setTotalPages(1);
                } finally {
                  setLoading(false);
                  dispatch({
                    type: FETCH_PURCHASE_ORDER_LOADING,
                    payload: false,
                  });
                }
              }}
            >
              <MenuItem value="View all PO">View all PO</MenuItem>
              <MenuItem value="View PO with shortages">View PO with shortages (Actual Qty {'<'} Stat Qty)</MenuItem>
              {/* F4a: Replaced "View PO with delays" with "View PO with RTP misses" */}
              <MenuItem value="View PO with RTP misses">View PO with RTP misses</MenuItem>
              <MenuItem value="View PO with new artwork">View PO with new artwork</MenuItem>
              {/* F4b: New date-based filter options */}
              <MenuItem value="View POs with Stat Date of this month">View POs with Stat Date of this month</MenuItem>
              <MenuItem value="View POs with Stat Date of previous month">View POs with Stat Date of previous month</MenuItem>
              <MenuItem value="View POs with SAP Posting Date of this month">View POs with SAP Posting Date of this month</MenuItem>
              <MenuItem value="View POs with SAP Posting Date of previous month">View POs with SAP Posting Date of previous month</MenuItem>
            </Select>
          </FormControl>
        </Box>

        {/* Last Synced and Per Page Section */}
        <Box className={classes.syncGroup} style={{ flex: 1 }}>
          <Box style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", cursor: "pointer", flexWrap: "wrap", gap: "8px" }}>
            <Typography
              variant="body2"
              style={{
                color: "gray",
                marginRight: "4px",
                whiteSpace: "nowrap",
                fontSize: "12px",
              }}
              className="last-synced-text"
            >
              {`Last synced @ ${moment(lastSynced).format(
                "HH:mm:ss; DD MMMM, YYYY"
              )}`}
            </Typography>
            <Typography
              variant="body2"
              color="primary"
              style={{
                textDecoration: "underline",
                fontStyle: "italic",
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                marginRight: "4px",
              }}
              className="refresh-button"
              onClick={handleRefresh}
            >
              Refresh
              <Refresh color="primary" fontSize="small" className="refresh-button" />
            </Typography>
          </Box>
          <Box
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              marginTop: "4px",
              width: "100%",
            }}
            className="per-page-box"
          >
            <Typography variant="body2" style={{ fontSize: "14px", fontWeight: "bold", marginRight: "4px", whiteSpace: "nowrap" }}>PER PAGE</Typography>
            <FormControl variant="outlined" size="small" style={{ minWidth: 80 }}>
              <Select
                value={rowsPerPage}
                onChange={handleRowsPerPageChange}
              >
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={25}>25</MenuItem>
                <MenuItem value={50}>50</MenuItem>
                <MenuItem value={100}>100</MenuItem>
              </Select>
            </FormControl>
          </Box>
        </Box>
      </Box>

      {/* Table Section */}
      <Box className={classes.tableContainer}>
        <InactivePOTable
          data={poData}
          loading={loading}
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
          featuresAccess={featuresAccess}
          onRefresh={handleRefresh}
        />
      </Box>

      {/* Success Dialog (same as PO Dashboard) */}
      <Dialog open={savedSuccessfull} fullWidth>
        <StyledDialog
          icons={true}
          handleClose={handleCloseSave}
          title={"Saved successfully"}
        />
      </Dialog>

      {/* Reset Batch Dialog */}
      <ResetBatchDialogInactive
        open={resetBatchDialogOpen}
        onClose={() => {
          setResetBatchDialogOpen(false);
          setConsumptionError(null);
        }}
        isLoading={consumptionLoading}
        onContinue={async (data) => {
          if (data.reasonForReset === 'Consumption rejected by mistake') {
            setConsumptionLoading(true);
            setConsumptionError(null);
            setResetBatchData(data);

            try {
              const payload = [{
                poNumber: data.poNumber,
                batchNumber: data.batchNumber,
                schrockenDeliveryScheduleBatchID: data.schrockenDeliveryScheduleBatchID,
                consumptionResetRequested: true,
                vendorMosymphonyID: data.vendorMosymphonyID,
              }];

              const response = await axios.post(
                `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/updateFGBatchForWorkflowReset`,
                payload
              );

              setResetBatchDialogOpen(false);

              if (response.data?.status) {
                setConsumptionError(null);
                setSuccessDialogOpen(true);
              } else {
                setConsumptionError(response.data?.message || 'Failed to reset consumption. Please try again.');
                setSuccessDialogOpen(true);
              }
            } catch (error) {
              console.error('Error calling updateFGBatchForWorkflowReset API:', error);
              setResetBatchDialogOpen(false);
              setConsumptionError(error.response?.data?.message || 'An error occurred. Please try again.');
              setSuccessDialogOpen(true);
            } finally {
              setConsumptionLoading(false);
            }
          } else {
            // For document resubmission options, close ResetBatchDialog and open DocumentResubmissionDialog
            setResetBatchDialogOpen(false);
            setResetBatchData(data);
            setDocumentResubmissionDialogOpen(true);
          }
        }}
      />

      <DocumentResubmissionDialog
        open={documentResubmissionDialogOpen}
        onClose={() => setDocumentResubmissionDialogOpen(false)}
        batchData={resetBatchData}
        reasonForReset={resetBatchData?.reasonForReset}
        onSuccess={() => {
          setDocumentResubmissionDialogOpen(false);
          setSuccessDialogOpen(true);
        }}
      />

      {/* Success/Error Dialog */}
      <Dialog
        open={successDialogOpen}
        onClose={() => {
          setSuccessDialogOpen(false);
          setConsumptionError(null);
        }}
        maxWidth="xs"
        fullWidth
        PaperProps={{ style: { borderRadius: 12 } }}
      >
        <DialogContent style={{ textAlign: 'center', padding: '32px 48px' }}>
          {consumptionError ? (
            <>
              <ErrorIcon style={{ fontSize: 60, color: '#f44336', marginBottom: '16px' }} />
              <Typography style={{ fontWeight: 600, fontSize: '1.125rem', marginBottom: '16px', color: '#f44336' }}>
                Error
              </Typography>
              <Typography style={{ color: '#f44336', marginBottom: '24px', fontSize: '0.875rem' }}>
                {consumptionError}
              </Typography>
            </>
          ) : (
            <>
              <CheckCircleIcon style={{ fontSize: 60, color: '#2e7d32', marginBottom: '16px' }} />
              <Typography style={{ fontWeight: 600, fontSize: '1.125rem', marginBottom: '24px' }}>
                {resetBatchData?.reasonForReset === 'Consumption rejected by mistake'
                  ? 'Batch Reset Successfully'
                  : 'Document Resubmission Request sent to CMO Successfully'}
              </Typography>
            </>
          )}
          <Button
            onClick={() => {
              setSuccessDialogOpen(false);
              setConsumptionError(null);
            }}
            style={{
              backgroundColor: '#e36e39',
              color: '#FFFFFF',
              borderRadius: 20,
              padding: '6px 32px',
              textTransform: 'none',
              fontWeight: 500,
              transition: 'all 0.3s ease-in-out',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#c44d15';
              e.currentTarget.style.boxShadow = '0 4px 12px rgba(227, 110, 57, 0.4)';
              e.currentTarget.style.transform = 'translateY(-1px)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '#e36e39';
              e.currentTarget.style.boxShadow = 'none';
              e.currentTarget.style.transform = 'translateY(0)';
            }}
            onMouseDown={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 2px 6px rgba(227, 110, 57, 0.3)';
            }}
            onMouseUp={(e) => {
              e.currentTarget.style.transform = 'translateY(-1px)';
              e.currentTarget.style.boxShadow = '0 4px 12px rgba(227, 110, 57, 0.4)';
            }}
          >
            OK
          </Button>
        </DialogContent>
      </Dialog>

      {/* Error Dialog (same as PO Dashboard) */}
      <Dialog
        open={saveFailed}
        onClose={() => {
          setSaveFailed(false);
          setSavingFilters(false);
        }}
        fullWidth
      >
        <DialogContent style={{ padding: "2rem" }}>
          <Grid container justifyContent="flex-end">
            <Typography
              variant="body2"
              style={{
                fontSize: "1rem",
                fontWeight: 500,
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
              }}
              onClick={() => {
                setSaveFailed(false);
                setSavingFilters(false);
              }}
            >
              Close <CloseIcon fontSize="large" />
            </Typography>
            <Grid
              item
              xs={12}
              style={{ display: "flex", justifyContent: "center" }}
            >
              <WarningIcon
                style={{
                  fontSize: "5rem",
                  color: "#F00",
                }}
              />
            </Grid>
          </Grid>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "80px",
              border: "2px solid #FF0000",
              backgroundColor: "#FFF0F0",
            }}
          >
            <Typography style={{ textAlign: "center" }}>
              Something went wrong. Please try again.
            </Typography>
          </div>
        </DialogContent>
      </Dialog>

      {/* Excel Preview Dialog */}
      <Dialog
        open={openExcelPreview}
        onClose={(event, reason) => {
          if (reason !== 'backdropClick') {
            handleCloseExcelPreview();
          }
        }}
        fullWidth
        maxWidth="lg"
        PaperProps={{ style: { borderRadius: 14 } }}
        disableEscapeKeyDown
      >
        <DialogContent style={{ padding: 24 }}>
          <Grid container justifyContent="flex-end" style={{ marginBottom: 8 }}>
            <Typography
              style={{
                fontSize: "1rem",
                fontWeight: 500,
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
              }}
              onClick={handleCloseExcelPreview}
            >
              Close <CloseIcon style={{ marginLeft: 4, color: "#FF0000" }} fontSize="large" />
            </Typography>
          </Grid>

          <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
            <Box display="flex" alignItems="center">
              <img
                src="https://img.icons8.com/color/96/000000/microsoft-excel-2019--v1.png"
                alt="Excel file"
                style={{ width: '48px', height: '48px', marginRight: '16px' }}
              />
              <Box>
                <Typography variant="h6" style={{ margin: 0, fontWeight: 600 }}>
                  Inactive Purchase Orders Data
                </Typography>
                <Typography variant="body2" style={{ margin: 0, color: '#666' }}>
                  Excel Spreadsheet Preview
                </Typography>
              </Box>
            </Box>
            <Box display="flex" gap={2}>
              {excelFileURL && (
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<CloudDownload />}
                  href={excelFileURL}
                  download={excelFileName}
                  style={{ textTransform: 'none' }}
                >
                  Download
                </Button>
              )}
            </Box>
          </Box>

          {excelLoading ? (
            <Box display="flex" justifyContent="center" height="200px" alignItems="center">
              <CircularProgress color="primary" />
            </Box>
          ) : excelData && excelData.length > 0 ? (
            <>
              <TableContainer ref={tableContainerRef} component={Paper} style={{ maxHeight: '400px', overflowY: 'auto', overflowX: 'auto' }}>
                <Table size="small" style={{ position: 'relative', borderCollapse: 'separate', borderSpacing: 0 }}>
                  <TableHead>
                    <TableRow>
                      {excelData[0] && excelData[0].map((cell, i) => {
                        let bgColor = '#fff';
                        if (i < 16) {
                          bgColor = '#fff';
                        } else if (i < 23) {
                          bgColor = '#D0E0E3';
                        } else if (i < 34) {
                          bgColor = '#F4CCCC';
                        } else if (i < 45) {
                          bgColor = '#FCE5CD';
                        } else if (i < 49) {
                          bgColor = '#D9EAD3';
                        } else {
                          bgColor = '#FFF2CC';
                        }
                        return (
                          <TableCell
                            key={i}
                            style={{
                              fontWeight: 'bold',
                              backgroundColor: bgColor,
                              whiteSpace: 'nowrap',
                              borderTop: '1px solid #000',
                              borderLeft: '1px solid #000',
                              borderRight: '1px solid #000',
                              borderBottom: '1px solid #000',
                              textAlign: 'center',
                              color: '#000',
                              padding: '8px',
                              position: 'sticky',
                              top: 0,
                              zIndex: i === 0 ? 5 : 3,
                              left: i === 0 ? 0 : 'auto'
                            }}
                          >
                            {cell}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {(() => {
                      const headerRows = 1;
                      const dataRows = excelData.slice(headerRows);
                      const groupedData = groupRowsByPO(dataRows);
                      const paginatedGroups = groupedData.slice(
                        excelPage * 50,
                        (excelPage + 1) * 50
                      );
                      const renderedRows = [];

                      paginatedGroups.forEach((group, groupIdx) => {
                        const hasSubRows = group.subRows.length > 0;

                        renderedRows.push(
                          <TableRow key={`parent-${group.poNumber}-${groupIdx}`} hover>
                            {group.parentRow.map((cell, j) => {
                              const cellValue = cell !== null && cell !== undefined ? String(cell) : '';
                              const hasLineBreaks = cellValue.includes('\n');
                              let bgColor = hasSubRows ? '#f5f5f5' : 'transparent';
                              // if (j >= 8 && j <= 11) {
                              //   bgColor = '#A3C3EF';
                              // }
                              return (
                                <TableCell
                                  key={j}
                                  style={{
                                    whiteSpace: hasLineBreaks ? 'pre-wrap' : 'nowrap',
                                    padding: '8px',
                                    borderTop: '1px solid #000',
                                    borderLeft: '1px solid #000',
                                    borderRight: '1px solid #000',
                                    borderBottom: hasSubRows ? '1px solid #ddd' : '1px solid #000',
                                    position: j === 0 ? 'sticky' : 'relative',
                                    left: j === 0 ? 0 : 'auto',
                                    backgroundColor: j === 0 ? '#fff' : bgColor,
                                    zIndex: j === 0 ? 2 : 'auto',
                                    fontWeight: 'normal',
                                    verticalAlign: 'top'
                                  }}
                                >
                                  {cellValue}
                                </TableCell>
                              );
                            })}
                          </TableRow>
                        );

                        if (hasSubRows) {
                          group.subRows.forEach((subRow, subIdx) => {
                            renderedRows.push(
                              <TableRow key={`sub-${group.poNumber}-${subIdx}`} hover>
                                {group.parentRow.map((cell, j) => {
                                  const subRowCell = subRow.row[j];
                                  const cellValue = subRowCell !== null && subRowCell !== undefined ? String(subRowCell) : '';
                                  const hasLineBreaks = cellValue.includes('\n');
                                  let bgColor = '#fafafa';
                                  if (j >= 8 && j <= 11) {
                                    bgColor = '#A3C3EF';
                                  }
                                  return (
                                    <TableCell
                                      key={j}
                                      style={{
                                        whiteSpace: hasLineBreaks ? 'pre-wrap' : 'nowrap',
                                        padding: '8px',
                                        paddingLeft: j === 0 ? '40px' : '8px',
                                        borderTop: '1px solid #ddd',
                                        borderLeft: '1px solid #000',
                                        borderRight: '1px solid #000',
                                        borderBottom: subIdx === group.subRows.length - 1 ? '1px solid #000' : '1px solid #ddd',
                                        position: j === 0 ? 'sticky' : 'relative',
                                        left: j === 0 ? 0 : 'auto',
                                        backgroundColor: j === 0 ? '#fff' : bgColor,
                                        zIndex: j === 0 ? 2 : 'auto',
                                        fontSize: '0.95em',
                                        verticalAlign: 'top'
                                      }}
                                    >
                                      {cellValue}
                                    </TableCell>
                                  );
                                })}
                              </TableRow>
                            );
                          });
                        }
                      });

                      return renderedRows;
                    })()}
                  </TableBody>
                </Table>
              </TableContainer>
              {(() => {
                const headerRows = 2;
                const dataRows = excelData.slice(headerRows);
                const totalPages = Math.ceil(dataRows.length / 50);
                return totalPages > 1 ? (
                  <Box display="flex" justifyContent="center" alignItems="center" mt={2}>
                    <IconButton
                      size="small"
                      onClick={() => {
                        setExcelPage((prev) => Math.max(prev - 1, 0));
                        if (tableContainerRef.current) {
                          tableContainerRef.current.scrollTop = 0;
                          tableContainerRef.current.scrollLeft = 0;
                        }
                      }}
                      disabled={excelPage === 0}
                      style={{ marginRight: 8 }}
                    >
                      <ChevronLeft fontSize="small" />
                    </IconButton>
                    <Typography>
                      Page {excelPage + 1} of {totalPages}
                    </Typography>
                    <IconButton
                      size="small"
                      onClick={() => {
                        setExcelPage((prev) => Math.min(prev + 1, totalPages - 1));
                        if (tableContainerRef.current) {
                          tableContainerRef.current.scrollTop = 0;
                          tableContainerRef.current.scrollLeft = 0;
                        }
                      }}
                      disabled={excelPage >= totalPages - 1}
                      style={{ marginLeft: 8 }}
                    >
                      <ChevronRight fontSize="small" />
                    </IconButton>
                  </Box>
                ) : null;
              })()}
            </>
          ) : (
            <Box display="flex" justifyContent="center" height="200px" alignItems="center">
              <Typography>No data available</Typography>
            </Box>
          )}
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default InactivePODashboard;

